module.exports=function(Bookhus,$,window,google,MarkerClusterer,setTimeout,clearTimeout,setInterval,clearInterval){
var Bookhus;
(function (Bookhus) {
    let SearchFilterType;
    (function (SearchFilterType) {
        SearchFilterType[SearchFilterType["Opvaskemaskine"] = 0] = "Opvaskemaskine";
        SearchFilterType[SearchFilterType["Vaskemaskine"] = 1] = "Vaskemaskine";
        SearchFilterType[SearchFilterType["T\u00F8rretumbler"] = 2] = "T\u00F8rretumbler";
        SearchFilterType[SearchFilterType["Husdyr"] = 3] = "Husdyr";
        SearchFilterType[SearchFilterType["Rygning"] = 4] = "Rygning";
        SearchFilterType[SearchFilterType["Br\u00E6ndeovn"] = 5] = "Br\u00E6ndeovn";
        SearchFilterType[SearchFilterType["Internet"] = 6] = "Internet";
        SearchFilterType[SearchFilterType["Parabol"] = 7] = "Parabol";
        SearchFilterType[SearchFilterType["Handicapvenligt"] = 8] = "Handicapvenligt";
        SearchFilterType[SearchFilterType["Havudsigt"] = 9] = "Havudsigt";
        SearchFilterType[SearchFilterType["MaxPrice"] = 10] = "MaxPrice";
        SearchFilterType[SearchFilterType["Spa"] = 11] = "Spa";
        SearchFilterType[SearchFilterType["Sauna"] = 12] = "Sauna";
        SearchFilterType[SearchFilterType["PoolOut"] = 13] = "PoolOut";
        SearchFilterType[SearchFilterType["PoolIn"] = 14] = "PoolIn";
        SearchFilterType[SearchFilterType["Garage"] = 15] = "Garage";
        SearchFilterType[SearchFilterType["Boat"] = 16] = "Boat";
        SearchFilterType[SearchFilterType["Ekkolod"] = 17] = "Ekkolod";
        SearchFilterType[SearchFilterType["VhsRadio"] = 18] = "VhsRadio";
        SearchFilterType[SearchFilterType["Radar"] = 19] = "Radar";
        SearchFilterType[SearchFilterType["MinTwoToilets"] = 20] = "MinTwoToilets";
        SearchFilterType[SearchFilterType["Fiskerenseplads"] = 21] = "Fiskerenseplads";
        SearchFilterType[SearchFilterType["Mikroovn"] = 22] = "Mikroovn";
        SearchFilterType[SearchFilterType["Cykler"] = 23] = "Cykler";
        SearchFilterType[SearchFilterType["Feriecenter"] = 24] = "Feriecenter";
        SearchFilterType[SearchFilterType["Swimmingpool"] = 25] = "Swimmingpool";
        SearchFilterType[SearchFilterType["Hus"] = 26] = "Hus";
        SearchFilterType[SearchFilterType["Lejlighed"] = 27] = "Lejlighed";
        SearchFilterType[SearchFilterType["Skiomr\u00E5de"] = 28] = "Skiomr\u00E5de";
        SearchFilterType[SearchFilterType["Storby"] = 29] = "Storby";
        SearchFilterType[SearchFilterType["Bjergby"] = 30] = "Bjergby";
        SearchFilterType[SearchFilterType["UdsigtVand"] = 31] = "UdsigtVand";
        SearchFilterType[SearchFilterType["UdsigtNatur"] = 32] = "UdsigtNatur";
        SearchFilterType[SearchFilterType["LadeStander"] = 33] = "LadeStander";
        SearchFilterType[SearchFilterType["Varmepumpe"] = 34] = "Varmepumpe";
        SearchFilterType[SearchFilterType["HusdyrIkkeTilladt"] = 35] = "HusdyrIkkeTilladt";
    })(SearchFilterType = Bookhus.SearchFilterType || (Bookhus.SearchFilterType = {}));
    let PromiseType;
    (function (PromiseType) {
        PromiseType[PromiseType["loadLocations"] = 0] = "loadLocations";
        PromiseType[PromiseType["loadRelationships"] = 1] = "loadRelationships";
        PromiseType[PromiseType["searchData"] = 2] = "searchData";
        PromiseType[PromiseType["loadControlSettings"] = 3] = "loadControlSettings";
    })(PromiseType || (PromiseType = {}));
    class HouseLocation {
    }
    Bookhus.HouseLocation = HouseLocation;
    class SearchwidgetDataservice {
        constructor() {
            this.searchCridentials = null;
            this.promises = [];
        }
        loadDataAjax() {
            var xhr = $.getJSON('/api/housesearch?getAll=true', (markers) => {
                this.markers = markers;
            });
            return xhr;
        }
        searchData(filters) {
            var self = this;
            if (filters) {
                self.searchCridentials = filters;
            }
            if (self.promises[PromiseType.searchData]) {
                return self.promises[PromiseType.searchData];
            }
            self.promises[PromiseType.searchData] = $.getJSON("/api/housesearch", self.searchCridentials, (markers) => {
                self.markers = markers;
            });
            self.promises[PromiseType.searchData].done(() => {
                self.promises[PromiseType.searchData] = null;
            });
            return self.promises[PromiseType.searchData];
        }
        loadControlSettings() {
            var self = this;
            if (self.promises[PromiseType.loadControlSettings]) {
                return self.promises[PromiseType.loadControlSettings];
            }
            self.promises[PromiseType.loadControlSettings] = $.getJSON("/api/housesearch/getcontrols", { _: new Date().getTime() }, (controlSettings) => {
                self.controlSettings = controlSettings;
            });
            self.promises[PromiseType.loadControlSettings].done(() => {
                self.promises[PromiseType.loadControlSettings] = null;
            });
            return self.promises[PromiseType.loadControlSettings];
        }
        loadLocations() {
            var self = this;
            if (self.promises[PromiseType.loadLocations]) {
                return self.promises[PromiseType.loadLocations];
            }
            self.promises[PromiseType.loadLocations] = $.getJSON("/api/housesearch/getlocations", { _: new Date().getTime() }, (locations) => {
                self.locations = locations;
            });
            self.promises[PromiseType.loadLocations].done(() => {
                self.promises[PromiseType.loadLocations] = null;
            });
            return self.promises[PromiseType.loadLocations];
        }
        loadRelationships() {
            var self = this;
            if (self.promises[PromiseType.loadRelationships]) {
                return self.promises[PromiseType.loadRelationships];
            }
            self.promises[PromiseType.loadRelationships] = $.getJSON("/api/housesearch/getRelationships", { _: new Date().getTime() }, (relationships) => {
                self.relationships = relationships;
            });
            self.promises[PromiseType.loadRelationships].done(() => {
                self.promises[PromiseType.loadRelationships] = null;
            });
            return self.promises[PromiseType.loadRelationships];
        }
        getGoogleMarkers(googleMap, overlay) {
            var self = this;
            var result = [];
            if (googleMap == null || overlay == null || googleMap == undefined) {
                return result;
            }
            self.markers.forEach((marker) => {
                var googleMarker = new google.maps.Marker({
                    position: marker.position,
                    icon: {
                        url: SearchwidgetDataservice.BOOKHUS_GREY_PIN,
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    title: marker.title,
                    map: googleMap,
                    markerId: 0,
                    markerType: null
                });
                var content = `<span id="infowindow_${marker.type}_${marker.id}"></span>${marker.description}`;
                var infowindow = new google.maps.InfoWindow({
                    content: content,
                    disableAutoPan: true
                });
                googleMarker.addListener("click", () => {
                    var self = this;
                    infowindow.open(googleMap, googleMarker);
                });
                google.maps.event.addListener(infowindow, 'domready', function () {
                    var img = $("#iw-container-" + marker.id + " img");
                    var url = img.data("src");
                    img.attr("src", url);
                    var projection = overlay.getProjection();
                    //Convert position to pixel
                    var point = projection.fromLatLngToContainerPixel(googleMarker.getPosition());
                    var container = $(`#infowindow_${marker.type}_${marker.id}`).parents('.gm-style-iw.gm-style-iw-c:first');
                    //Calculate new latlng based on pixel
                    point.y = point.y - (container.height() / 2) - 20;
                    //Convert pixel back to position
                    var position = projection.fromContainerPixelToLatLng(point);
                    googleMap.panTo(position);
                });
                result.push(googleMarker);
            });
            return result;
        }
        GetCssIcon(type) {
            switch (type) {
                case SearchFilterType.Opvaskemaskine:
                    return "bookhusicon bookhusicon_28";
                case SearchFilterType.Vaskemaskine:
                    return "bookhusicon bookhusicon_34";
                case SearchFilterType.Tørretumbler:
                    return "bookhusicon bookhusicon_33";
                case SearchFilterType.Husdyr:
                    return "bookhusicon bookhusicon_8";
                case SearchFilterType.HusdyrIkkeTilladt:
                    return "fak fa-pet-ban";
                case SearchFilterType.Rygning:
                    return "bookhusicon bookhusicon_18";
                case SearchFilterType.Brændeovn:
                    return "bookhusicon bookhusicon_121";
                case SearchFilterType.Internet:
                    return "bookhusicon bookhusicon_117";
                case SearchFilterType.Parabol:
                    return "bookhusicon bookhusicon_112";
                case SearchFilterType.Handicapvenligt:
                    return "bookhusicon bookhusicon_116";
                case SearchFilterType.Havudsigt:
                    return "bookhusicon bookhusicon_0";
                case SearchFilterType.MaxPrice:
                    return "bookhusicon bookhusicon_124";
                case SearchFilterType.Spa:
                    return "bookhusicon bookhusicon_125";
                case SearchFilterType.Sauna:
                    return "bookhusicon bookhusicon_128";
                case SearchFilterType.PoolOut:
                    return "bookhusicon bookhusicon_103";
                case SearchFilterType.PoolIn:
                    return "bookhusicon bookhusicon_103";
                case SearchFilterType.Garage:
                    return "bookhusicon bookhusicon_129";
                case SearchFilterType.Boat:
                    return "bookhusicon bookhusicon_1";
                case SearchFilterType.Ekkolod:
                    return "bookhusicon bookhusicon_39";
                case SearchFilterType.VhsRadio:
                    return "bookhusicon bookhusicon_85";
                case SearchFilterType.Radar:
                    return "bookhusicon bookhusicon_143";
                case SearchFilterType.MinTwoToilets:
                    return "bookhusicon bookhusicon_107";
                case SearchFilterType.Fiskerenseplads:
                    return "bookhusicon bookhusicon_39";
                case SearchFilterType.Mikroovn:
                    return "bookhusicon bookhusicon_36";
                case SearchFilterType.Cykler:
                    return "bookhusicon bookhusicon_6";
                case SearchFilterType.Feriecenter:
                    return "bookhusicon bookhusicon_132";
                case SearchFilterType.Swimmingpool:
                    return "bookhusicon bookhusicon_15";
                case SearchFilterType.Hus:
                    return "bookhusicon bookhusicon_129";
                case SearchFilterType.Lejlighed:
                    return "bookhusicon bookhusicon_129";
                case SearchFilterType.Skiområde:
                    return "bookhusicon bookhusicon_45";
                case SearchFilterType.Storby:
                    return "bookhusicon bookhusicon_86";
                case SearchFilterType.Bjergby:
                    return "bookhusicon bookhusicon_86";
                case SearchFilterType.UdsigtVand:
                    return "bookhusicon bookhusicon_0";
                case SearchFilterType.UdsigtNatur:
                    return "bookhusicon bookhusicon_78";
                case SearchFilterType.LadeStander:
                    return "";
                case SearchFilterType.Varmepumpe:
                    return "";
                default:
                    return "";
            }
        }
        setPartialSearchCridentials(filters) {
            var self = this;
            self.extend(self.searchCridentials, filters);
        }
        extend(oldObject, newObject) {
            var self = this;
            if (oldObject == null) {
                oldObject = {};
            }
            for (var key in newObject) {
                oldObject[key] = newObject[key];
            }
            self.searchCridentials = oldObject;
        }
    }
    SearchwidgetDataservice.BOOKHUS_GREY_PIN = '/content/siteimages/googleMarkers/bookhus_grey_pin.svg';
    SearchwidgetDataservice.BOOKHUS_RED_PIN = '/content/siteimages/googleMarkers/bookuhs_red_pin.svg';
    SearchwidgetDataservice.BOOKHUS_RED_OUTLINE_PIN = '/content/siteimages/googleMarkers/bookhus_red_outline_pin.svg';
    Bookhus.SearchwidgetDataservice = SearchwidgetDataservice;
})(Bookhus || (Bookhus = {}));
/// <reference path="../../Scripts/MarkerClusterer/markerClusterer.d.ts"/>
var Bookhus;
(function (Bookhus) {
    class Searchwidget {
        constructor(settings) {
            this.markers = [];
            var self = this;
            var options = Object.assign({ zoom: 6, maxFitZoom: 10, mapType: false, mapTypePosition: "TOP_CENTER", mapTypeStyle: "DROPDOWN_MENU" }, settings.options);
            settings = Object.assign(Object.assign({ containerSelector: "", disableSearch: false, autoOpen: false, useMarkerCluster: false }, settings), { options: options });
            self.settings = settings;
            self.container = $(self.settings.containerSelector);
            self.setContainers();
            self.dataService = new Bookhus.SearchwidgetDataservice();
        }
        getSearchWidgetLanguage() {
            var bookhus = window.Bookhus;
            if (bookhus
                && bookhus.Localization
                && bookhus.Localization.Standard
                && bookhus.Localization.Standard.UI
                && bookhus.Localization.Standard.UI.Widgets) {
                return bookhus.Localization.Standard.UI.Widgets.SearchWidget;
            }
            return null;
        }
        translate(name) {
            var searchWidgetLanguage = this.getSearchWidgetLanguage();
            if (!searchWidgetLanguage) {
                return "";
            }
            switch (name) {
                case "HavDistance":
                    return searchWidgetLanguage.HavDistance || searchWidgetLanguage.Hav || "";
                case "KøbmandDistance":
                    return searchWidgetLanguage.KøbmandDistance || searchWidgetLanguage.Købmand || "";
                case "MaxPrice":
                    return searchWidgetLanguage.MaxPrice || searchWidgetLanguage["Maks pris"] || "";
                default:
                    return searchWidgetLanguage[name] || "";
            }
        }
        init() {
            var self = this;
            if (self.mapContainer === null || self.mapContainer === undefined) {
                return;
            }
            if (self.mapContainer.length === 0) {
                return;
            }
            //container[0] er selve dom elementet 
            var map = new google.maps.Map(self.mapContainer[0], {
                disableDefaultUI: true,
                center: { lat: 55.814666, lng: 10.588629 },
                zoom: self.settings.options.zoom,
                streetViewControl: true,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                scaleControl: false,
                rotateControl: false,
                mapTypeControl: self.settings.options.mapType,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle[self.settings.options.mapTypeStyle],
                    position: google.maps.ControlPosition[self.settings.options.mapTypePosition]
                }
            });
            self.container.css('backgroundImage', 'none');
            self.map = map;
            var overlay = new google.maps.OverlayView();
            overlay.draw = function () { };
            overlay.onAdd = function () {
                //var projection = this.getProjection();
                //var pixel = projection.fromLatLngToContainerPixel(marker.getPosition());
                //console.log(pixel);
            };
            overlay.setMap(map);
            self.overlay = overlay;
            //Get data
            self.loadData();
            if (!self.settings.disableSearch) {
                $.when(self.dataService.loadControlSettings(), self.dataService.loadLocations()).done(() => {
                    self.renderFilters();
                    self.initializeMaps();
                });
            }
            if (self.settings.useMarkerCluster) {
                self.cluster = new MarkerClusterer(self.map, []);
                self.cluster.setAverageCenter(true);
            }
        }
        setContainers() {
            var self = this;
            if (!self.settings.disableSearch) {
                self.container.html(`
<div class="search-filter-box"><span class="fa fa-search" aria-hidden="true"></span><span style="font-size: 0.5em;">Søg</span></div>
<div class="google-search-map"></div>
<div class="google-search-filter brand-background-transparent"></div>
`);
                self.mapContainer = self.container.find('.google-search-map');
                self.searchContainer = self.container.find('.google-search-filter');
                self.searchButton = self.container.find('.search-filter-box');
            }
            else {
                self.container.html(`<div class="google-search-map"></div>`);
                self.mapContainer = self.container.find('.google-search-map');
            }
        }
        toggleFilterTimer(element) {
            var self = this;
            var lastFilterElem;
            self.filterTimer = setInterval(() => {
                var filter = $(element);
                var selected = filter.children('option:selected');
                if (lastFilterElem && lastFilterElem[0] != selected[0]) {
                    clearInterval(self.filterTimer);
                    return;
                }
                var nextElem;
                if (filter.children('option:last')[0] != selected[0]) {
                    nextElem = selected.next('option');
                }
                else {
                    nextElem = filter.children('option:first');
                }
                filter.val(nextElem.val());
                lastFilterElem = nextElem;
                filter.trigger('change');
            }, 1000 * 10);
        }
        renderFilters() {
            var self = this;
            var controls = "";
            if (self.dataService.controlSettings.showPeriod) {
                var weeks = `<option value="0">1 ${self.translate("Dag")}</option>`;
                for (var i = 1; i < (self.dataService.controlSettings.maxPeriodDays || 28); i++) {
                    var tekst = "";
                    if ((i + 1) % 7 == 0) {
                        var week = (i + 1) / 7;
                        if (week == 1) {
                            tekst = week + " " + self.translate("Uge");
                        }
                        else {
                            tekst = week + " " + self.translate("Uger");
                        }
                    }
                    else {
                        tekst = (i + 1) + " " + self.translate("Dage");
                    }
                    weeks += `<option ${i == 6 ? "selected" : ""} value="${i}">${tekst}</option>`;
                }
                controls += `
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>${self.translate("Periode")}</label>
                            <div class="row">
                                <div class="col-md-6">
                                    <input type="text" id="startDate" name="arrivalDate" placeholder="${self.translate("StartDato")}" class="datePicker form-control"/>
                                </div>
                                <div class="col-md-6">
                                    <select class="form-control" id="periodWeeks" name="days">
                                        ${weeks}
                                    </select>                                                
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }
            if (self.dataService.controlSettings.showRooms) {
                var rooms = "";
                for (var i = 2; i <= (self.dataService.controlSettings.maxRooms || 4); i++) {
                    rooms += `<option value="${i}">${i} ${self.translate("Værelser")}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("Værelser")}</label>
                            <select class="form-control" name="roomcount">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                <option value="1">1 ${self.translate("Værelse")}</option>
                                ${rooms}
                            </select>
                        </div>            
                    </div>
                `;
            }
            if (self.dataService.controlSettings.showPersons) {
                var persons = "";
                for (var i = 2; i <= (self.dataService.controlSettings.maxPersons || 8); i++) {
                    persons += `<option value="${i}">${i} ${self.translate("Personer")}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("AntalPersoner")}</label>
                            <select class="form-control" name="personcount">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                <option value="1">1 ${self.translate("Person")}</option>
                                ${persons}
                            </select>
                        </div>
                    </div>
                `;
            }
            if (self.dataService.controlSettings.showDistanceToSea) {
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("HavDistance")}</label>
                            <select class="form-control" name="havDistance">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
            }
            if (self.dataService.controlSettings.showDistanceToGrocer) {
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("KøbmandDistance")}</label>
                            <select class="form-control" name="købmandDistance">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
            }
            if (self.dataService.controlSettings.showArea) {
                var locationData = self.dataService.locations || [];
                var locations = "";
                for (var i = 0; i < locationData.length; i++) {
                    locations += `<option value="${locationData[i].id}">${locationData[i].name}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("Område")}</label>
                            <select class="form-control" id="locations" name="lokation">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                ${locations}
                            </select>
                        </div>
                    </div>
                `;
            }
            var facilities = "";
            var filters = self.dataService.controlSettings.facilities || [];
            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                facilities += `
                    <div class="col-md-4">
                        <span class="${self.dataService.GetCssIcon(filter)} brand-background" style="height: 27px; width: 27px; font-size: 1.75em; margin-right: 5px;"></span>
                        <label style="position: absolute; font-weight: normal; margin-bottom: 0;">
                        <input type="checkbox"  name="${Bookhus.SearchFilterType[filter]}"/> ${self.translate(Bookhus.SearchFilterType[filter])}</label>    
                    </div>
                `;
            }
            var html = "";
            html = `
<div>
    <div class="row">
        <div class="col-md-12">
            <h4 style="color:white; display: inline;">${self.translate("Søg")}</h4>
        </div>
    </div>
    <div class="row">
        ${controls}
    </div>    
    <div class="row">
        <div class="col-md-12"><label>${self.translate("Faciliteter")}</label></div>
        ${facilities}
    </div>
</div>
<span class="btnGroup pull-right">
    <button type="button" data-command="resetFilters">${self.translate("Nulstil")}</button>                    
    <button type="button" data-command="showInCatalog">${self.translate("VisKatalog")}</button>
</span>
`;
            self.searchContainer.html(html);
            if (self.settings.autoOpen) {
                self.searchContainer.addClass('open');
            }
        }
        initializeMaps() {
            var self = this;
            self.map.addListener('tilesloaded', () => {
                $('.google-search-filter').css('display', 'block');
            });
            $(".search-filter-box").on("click", (e) => {
                $('.google-search-filter').toggleClass('open');
                clearInterval(self.filterTimer);
            });
            //Fullscreen button
            self.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(document.createElement('div'));
            //FullScreenControl(self.map, "Gør større", "Gør mindre"));
            //Dropdown filter menu
            var locationSelector = document.createElement('select');
            locationSelector.className = "googlestyle-dropdown";
            var temp = document.createElement('option');
            temp.value = "0";
            temp.innerText = "Alle steder";
            locationSelector.appendChild(temp);
            var locationData = self.dataService.locations;
            for (var i = 0; i < locationData.length; i++) {
                var option = document.createElement('option');
                option.value = locationData[i].id.toString();
                option.innerText = locationData[i].name;
                locationSelector.appendChild(option);
            }
            $(locationSelector).on('change', (e) => {
                $('#locations').val($(e.target).val());
                $('#locations').change();
            });
            self.map.controls[google.maps.ControlPosition["TOP_LEFT"]].push(locationSelector);
            //self.toggleFilterTimer(locationSelector);
            $('.google-search-filter input, .google-search-filter select').on('change', (e) => {
                var current = $(e.target);
                if (current.attr('name') === 'lokation') {
                    $(locationSelector).val(current.val());
                }
                if (current.is(':checked') && (current.attr('name') === 'Husdyr' || current.attr('name') === 'HusdyrIkkeTilladt')) {
                    var oppositeName = current.attr('name') === 'Husdyr' ? 'HusdyrIkkeTilladt' : 'Husdyr';
                    self.searchContainer.find(`input[name="${oppositeName}"]`).prop('checked', false);
                }
                self.loadFilteredData();
            });
            $('.google-search-filter :text').on('keyup', () => {
                self.debounce(self.loadFilteredData(), 100);
            });
            $('[data-command="resetFilters"]').on('click', (e) => {
                $(self.searchContainer.find('input, select, textarea')).each((index, element) => {
                    var current = $(element);
                    if (current.prop('type') == "checkbox") {
                        current.prop('checked', false);
                        return;
                    }
                    if (current.attr('name') == "days") {
                        current.val('6');
                        return;
                    }
                    if (current.attr('name') == "købmandDistance" || current.attr('name') == "havDistance") {
                        current.val('-1');
                        return;
                    }
                    if (current.prop('nodeName') == "INPUT" || current.prop('nodeName') == "TEXTAREA") {
                        current.val('');
                        return;
                    }
                    if (current.prop('nodeName') == "SELECT") {
                        current.val('0');
                        return;
                    }
                });
                self.loadData();
            });
            $('[data-command="showInCatalog"]').on('click', () => {
                var params = [];
                var hasActiveFilter = false;
                $(self.searchContainer.find('input[name], select[name], textarea[name]')).each((index, element) => {
                    var current = $(element);
                    var value;
                    if (current.prop('type') == "checkbox") {
                        value = current.is(':checked');
                    }
                    else {
                        value = current.val();
                    }
                    var name = current.attr('name');
                    hasActiveFilter = hasActiveFilter || self.isCatalogFilterActive(name, value);
                    params.push(encodeURIComponent(name) + "=" + encodeURIComponent(value == null ? "" : value.toString()));
                });
                var houseIds = self.getCurrentHouseIds();
                if (hasActiveFilter && houseIds) {
                    params.push("houseIds=" + encodeURIComponent(houseIds));
                }
                params.push("bypassCache=true");
                window.location.href = "/catalog?" + params.join("&");
            });
            BindCalendars();
        }
        isCatalogFilterActive(name, value) {
            if (value == null || value === "" || value === false || value === "false") {
                return false;
            }
            if (name === "days") {
                return false;
            }
            if (name === "roomcount" || name === "personcount" || name === "lokation") {
                return parseInt(value, 10) > 0;
            }
            if (name === "havDistance" || name === "købmandDistance") {
                return parseInt(value, 10) > -1;
            }
            return true;
        }
        getCurrentHouseIds() {
            var houseIds = [];
            if (!this.dataService || !this.dataService.markers) {
                return "";
            }
            this.dataService.markers.forEach((marker) => {
                if (marker.type !== MarkerType.house || houseIds.indexOf(marker.id) > -1) {
                    return;
                }
                houseIds.push(marker.id);
            });
            return houseIds.join(",");
        }
        loadData() {
            var self = this;
            var xhr = this.dataService.loadDataAjax();
            xhr.always(() => {
                this.clearMap();
                if (self.settings.useMarkerCluster) {
                    this.updateMapClusterer();
                }
                else {
                    this.updateMap();
                }
                this.fitBounds();
            });
        }
        updateMap() {
            var self = this;
            // sæt markører ind..
            // de ligger i this.dataService.houses            
            this.dataService.markers.forEach((element) => {
                var marker = new google.maps.Marker({
                    position: element.position,
                    icon: {
                        url: Searchwidget.BOOKHUS_GREY_PIN,
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    map: this.map,
                    title: element.title,
                    markerId: 0,
                    markerType: null
                });
                var content = `<span id="infowindow_${element.type}_${element.id}"></span>${element.description}`;
                var infowindow = new google.maps.InfoWindow({
                    content: content,
                    disableAutoPan: true
                });
                marker.addListener("click", () => {
                    var self = this;
                    infowindow.open(self.map, marker);
                });
                google.maps.event.addListener(infowindow, 'domready', function () {
                    var img = $("#iw-container-" + element.id + " img");
                    var url = img.data("src");
                    img.attr("src", url);
                    var projection = self.overlay.getProjection();
                    //Convert position to pixel
                    var point = projection.fromLatLngToContainerPixel(marker.getPosition());
                    var container = $(`#infowindow_${element.type}_${element.id}`).parents('.gm-style-iw.gm-style-iw-c:first');
                    //Calculate new latlng based on pixel
                    point.y = point.y - (container.height() / 2) - 20;
                    //Convert pixel back to position
                    var position = projection.fromContainerPixelToLatLng(point);
                    self.map.panTo(position);
                });
                this.markers.push(marker);
            });
        }
        updateMapClusterer() {
            var self = this;
            self.cluster.clearMarkers();
            // sæt markører ind..
            // de ligger i this.dataService.houses            
            this.dataService.markers.forEach((element) => {
                var marker = new google.maps.Marker({
                    position: element.position,
                    icon: {
                        url: Searchwidget.BOOKHUS_GREY_PIN,
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    //map: this.map,
                    title: element.title,
                    markerId: 0,
                    markerType: null
                });
                var content = `<span id="infowindow_${element.type}_${element.id}"></span>${element.description}`;
                var infowindow = new google.maps.InfoWindow({
                    content: content,
                    disableAutoPan: true
                });
                marker.addListener("click", () => {
                    var self = this;
                    infowindow.open(self.map, marker);
                    var img = $("#iw-container-" + element.id + " img");
                    var url = img.data("src");
                    img.attr("src", url);
                    clearInterval(self.filterTimer);
                });
                google.maps.event.addListener(infowindow, 'domready', function () {
                    var projection = self.overlay.getProjection();
                    //Convert position to pixel
                    var point = projection.fromLatLngToContainerPixel(marker.getPosition());
                    var container = $(`#infowindow_${element.type}_${element.id}`).parents('.gm-style-iw:first').parent();
                    //Calculate new latlng based on pixel
                    point.y = point.y - (container.height() / 2) - 20;
                    //Convert pixel back to position
                    var position = projection.fromContainerPixelToLatLng(point);
                    self.map.panTo(position);
                });
                this.markers.push(marker);
            });
            self.cluster.addMarkers(self.markers, false);
        }
        clearMap() {
            this.markers.forEach((element) => {
                element.setMap(null);
            });
            this.markers = [];
        }
        loadFilteredData() {
            var self = this;
            var filters = {};
            $(self.searchContainer.find('input, select, textarea')).each((index, element) => {
                var current = $(element);
                if (current.prop('type') == "checkbox") {
                    filters[current.attr('name')] = current.is(':checked');
                }
                else {
                    filters[current.attr('name')] = current.val();
                }
            });
            if (filters.arrivalDate.length < 10 && filters.arrivalDate.length > 0) {
                return;
            }
            var xhr = this.dataService.searchData(filters);
            if (xhr) {
                xhr.always(() => {
                    this.clearMap();
                    if (this.dataService.markers.length > 0) {
                        if (self.settings.useMarkerCluster) {
                            this.updateMapClusterer();
                        }
                        else {
                            this.updateMap();
                        }
                        this.fitBounds();
                    }
                });
            }
        }
        fitBounds() {
            var self = this;
            if (this.markers && this.markers.length > 0) {
                var bounds = new google.maps.LatLngBounds();
                this.markers.forEach((element, index) => {
                    bounds.extend(this.markers[index].getPosition());
                });
                this.map.fitBounds(bounds);
                if (this.map.getZoom() > self.settings.options.maxFitZoom) {
                    this.map.setZoom(self.settings.options.maxFitZoom);
                }
                return;
            }
            this.map.setCenter({ lat: 55.814666, lng: 10.588629 });
            this.map.setZoom(self.settings.options.zoom);
            return;
        }
        debounce(fn, delay) {
            var timeoutId;
            return function debounced() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                var args = arguments;
                timeoutId = setTimeout(() => { fn.apply(this, args); }, delay);
            };
        }
    }
    Searchwidget.BOOKHUS_GREY_PIN = '/content/siteimages/googleMarkers/bookhus_grey_pin.svg';
    Searchwidget.BOOKHUS_RED_PIN = '/content/siteimages/googleMarkers/bookuhs_red_pin.svg';
    Searchwidget.BOOKHUS_RED_OUTLINE_PIN = '/content/siteimages/googleMarkers/bookhus_red_outline_pin.svg';
    Bookhus.Searchwidget = Searchwidget;
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    var SearchWidget;
    (function (SearchWidget) {
        let SearchFilterType;
        (function (SearchFilterType) {
            SearchFilterType[SearchFilterType["Opvaskemaskine"] = 0] = "Opvaskemaskine";
            SearchFilterType[SearchFilterType["Vaskemaskine"] = 1] = "Vaskemaskine";
            SearchFilterType[SearchFilterType["T\u00F8rretumbler"] = 2] = "T\u00F8rretumbler";
            SearchFilterType[SearchFilterType["Husdyr"] = 3] = "Husdyr";
            SearchFilterType[SearchFilterType["Rygning"] = 4] = "Rygning";
            SearchFilterType[SearchFilterType["Br\u00E6ndeovn"] = 5] = "Br\u00E6ndeovn";
            SearchFilterType[SearchFilterType["Internet"] = 6] = "Internet";
            SearchFilterType[SearchFilterType["Parabol"] = 7] = "Parabol";
            SearchFilterType[SearchFilterType["Handicapvenligt"] = 8] = "Handicapvenligt";
            SearchFilterType[SearchFilterType["Havudsigt"] = 9] = "Havudsigt";
            SearchFilterType[SearchFilterType["MaxPrice"] = 10] = "MaxPrice";
            SearchFilterType[SearchFilterType["Spa"] = 11] = "Spa";
            SearchFilterType[SearchFilterType["Sauna"] = 12] = "Sauna";
            SearchFilterType[SearchFilterType["PoolOut"] = 13] = "PoolOut";
            SearchFilterType[SearchFilterType["PoolIn"] = 14] = "PoolIn";
            SearchFilterType[SearchFilterType["Garage"] = 15] = "Garage";
            SearchFilterType[SearchFilterType["Boat"] = 16] = "Boat";
            SearchFilterType[SearchFilterType["Ekkolod"] = 17] = "Ekkolod";
            SearchFilterType[SearchFilterType["VhsRadio"] = 18] = "VhsRadio";
            SearchFilterType[SearchFilterType["Radar"] = 19] = "Radar";
            SearchFilterType[SearchFilterType["MinTwoToilets"] = 20] = "MinTwoToilets";
            SearchFilterType[SearchFilterType["Fiskerenseplads"] = 21] = "Fiskerenseplads";
            SearchFilterType[SearchFilterType["Mikroovn"] = 22] = "Mikroovn";
            SearchFilterType[SearchFilterType["Cykler"] = 23] = "Cykler";
            SearchFilterType[SearchFilterType["Feriecenter"] = 24] = "Feriecenter";
            SearchFilterType[SearchFilterType["Swimmingpool"] = 25] = "Swimmingpool";
            SearchFilterType[SearchFilterType["Hus"] = 26] = "Hus";
            SearchFilterType[SearchFilterType["Lejlighed"] = 27] = "Lejlighed";
            SearchFilterType[SearchFilterType["Skiomr\u00E5de"] = 28] = "Skiomr\u00E5de";
            SearchFilterType[SearchFilterType["Storby"] = 29] = "Storby";
            SearchFilterType[SearchFilterType["Bjergby"] = 30] = "Bjergby";
            SearchFilterType[SearchFilterType["UdsigtVand"] = 31] = "UdsigtVand";
            SearchFilterType[SearchFilterType["UdsigtNatur"] = 32] = "UdsigtNatur";
            SearchFilterType[SearchFilterType["LadeStander"] = 33] = "LadeStander";
            SearchFilterType[SearchFilterType["Varmepumpe"] = 34] = "Varmepumpe";
            SearchFilterType[SearchFilterType["HusdyrIkkeTilladt"] = 35] = "HusdyrIkkeTilladt";
        })(SearchFilterType = SearchWidget.SearchFilterType || (SearchWidget.SearchFilterType = {}));
        let PromiseType;
        (function (PromiseType) {
            PromiseType[PromiseType["loadLocations"] = 0] = "loadLocations";
            PromiseType[PromiseType["loadRelationships"] = 1] = "loadRelationships";
            PromiseType[PromiseType["searchData"] = 2] = "searchData";
            PromiseType[PromiseType["loadControlSettings"] = 3] = "loadControlSettings";
        })(PromiseType || (PromiseType = {}));
        class HouseLocation {
        }
        SearchWidget.HouseLocation = HouseLocation;
        class SearchwidgetDataservice {
            constructor() {
                this.searchCridentials = null;
                this.promises = [];
            }
            loadDataAjax() {
                var xhr = $.getJSON('/api/housesearch?getAll=true', (markers) => {
                    this.markers = markers;
                });
                return xhr;
            }
            searchData(filters) {
                var self = this;
                if (filters) {
                    self.searchCridentials = filters;
                }
                if (self.promises[PromiseType.searchData]) {
                    return self.promises[PromiseType.searchData];
                }
                self.promises[PromiseType.searchData] = $.getJSON("/api/housesearch", self.searchCridentials, (markers) => {
                    self.markers = markers;
                });
                self.promises[PromiseType.searchData].done(() => {
                    self.promises[PromiseType.searchData] = null;
                });
                return self.promises[PromiseType.searchData];
            }
            loadControlSettings() {
                var self = this;
                if (self.promises[PromiseType.loadControlSettings]) {
                    return self.promises[PromiseType.loadControlSettings];
                }
                self.promises[PromiseType.loadControlSettings] = $.getJSON("/api/housesearch/getcontrols", { _: new Date().getTime() }, (controlSettings) => {
                    self.controlSettings = controlSettings;
                });
                self.promises[PromiseType.loadControlSettings].done(() => {
                    self.promises[PromiseType.loadControlSettings] = null;
                });
                return self.promises[PromiseType.loadControlSettings];
            }
            loadLocations() {
                var self = this;
                if (self.promises[PromiseType.loadLocations]) {
                    return self.promises[PromiseType.loadLocations];
                }
                self.promises[PromiseType.loadLocations] = $.getJSON("/api/housesearch/getlocations", { _: new Date().getTime() }, (locations) => {
                    self.locations = locations;
                });
                self.promises[PromiseType.loadLocations].done(() => {
                    self.promises[PromiseType.loadLocations] = null;
                });
                return self.promises[PromiseType.loadLocations];
            }
            loadRelationship() {
                var self = this;
                if (self.promises[PromiseType.loadRelationships]) {
                    return self.promises[PromiseType.loadRelationships];
                }
                self.promises[PromiseType.loadRelationships] = $.getJSON("/api/housesearch/getRelationships", { _: new Date().getTime() }, (relationships) => {
                    self.relationships = relationships;
                });
                self.promises[PromiseType.loadRelationships].done(() => {
                    self.promises[PromiseType.loadRelationships] = null;
                });
                return self.promises[PromiseType.loadRelationships];
            }
            getGoogleMarkers(googleMap, overlay) {
                var self = this;
                var result = [];
                if (googleMap == null || overlay == null || googleMap == undefined) {
                    return result;
                }
                self.markers.forEach((marker) => {
                    var googleMarker = new google.maps.Marker({
                        position: marker.position,
                        icon: {
                            url: SearchwidgetDataservice.BOOKHUS_GREY_PIN,
                            scaledSize: new google.maps.Size(32, 32)
                        },
                        title: marker.title,
                        map: googleMap,
                        markerId: 0,
                        markerType: null
                    });
                    var content = `<span id="infowindow_${marker.type}_${marker.id}"></span>${marker.description}`;
                    var infowindow = new google.maps.InfoWindow({
                        content: content,
                        disableAutoPan: true
                    });
                    googleMarker.addListener("click", () => {
                        var self = this;
                        infowindow.open(googleMap, googleMarker);
                    });
                    google.maps.event.addListener(infowindow, 'domready', function () {
                        var img = $("#iw-container-" + marker.id + " img");
                        var url = img.data("src");
                        img.attr("src", url);
                        var projection = overlay.getProjection();
                        //Convert position to pixel
                        var point = projection.fromLatLngToContainerPixel(googleMarker.getPosition());
                        var container = $(`#infowindow_${marker.type}_${marker.id}`).parents('.gm-style-iw.gm-style-iw-c:first');
                        //Calculate new latlng based on pixel
                        point.y = point.y - (container.height() / 2) - 20;
                        //Convert pixel back to position
                        var position = projection.fromContainerPixelToLatLng(point);
                        googleMap.panTo(position);
                    });
                    result.push(googleMarker);
                });
                return result;
            }
            GetCssIcon(type) {
                switch (type) {
                    case SearchFilterType.Opvaskemaskine:
                        return "fas fa-washer";
                    case SearchFilterType.Vaskemaskine:
                        return "fas fa-washer";
                    case SearchFilterType.Tørretumbler:
                        return "fas fa-dryer";
                    case SearchFilterType.Husdyr:
                        return "fas fa-dog";
                    case SearchFilterType.HusdyrIkkeTilladt:
                        return "fak fa-pet-ban";
                    case SearchFilterType.Rygning:
                        return "fas fa-smoking";
                    case SearchFilterType.Brændeovn:
                        return "fas fa-fireplace";
                    case SearchFilterType.Internet:
                        return "fas fa-wifi";
                    case SearchFilterType.Parabol:
                        return "fas fa-satellite";
                    case SearchFilterType.Handicapvenligt:
                        return "fab fa-accessible-icon";
                    case SearchFilterType.Havudsigt:
                        return "fas fa-eye";
                    case SearchFilterType.MaxPrice:
                        return "fas fa-tags";
                    case SearchFilterType.Spa:
                        return "fas fa-hot-tub";
                    case SearchFilterType.Sauna:
                        return "fas fa-hot-tub";
                    case SearchFilterType.PoolOut:
                        return "fas fa-swimming-pool";
                    case SearchFilterType.PoolIn:
                        return "fas fa-swimming-pool";
                    case SearchFilterType.Garage:
                        return "fas fa-garage";
                    case SearchFilterType.Boat:
                        return "fas fa-ship";
                    case SearchFilterType.Ekkolod:
                        return "fas fa-39";
                    case SearchFilterType.VhsRadio:
                        return "fas fa-radio";
                    case SearchFilterType.Radar:
                        return "fas fa-radar";
                    case SearchFilterType.MinTwoToilets:
                        return "fas fa-toilet";
                    case SearchFilterType.Fiskerenseplads:
                        return "fas fa-fish";
                    case SearchFilterType.Mikroovn:
                        return "fas fa-microwave";
                    case SearchFilterType.Cykler:
                        return "fas fa-bicycle";
                    case SearchFilterType.Feriecenter:
                        return "fas fa-bags-shopping";
                    case SearchFilterType.Swimmingpool:
                        return "fas fa-swimming-pool";
                    case SearchFilterType.Hus:
                        return "fas fa-house";
                    case SearchFilterType.Lejlighed:
                        return "fas fa-building";
                    case SearchFilterType.Skiområde:
                        return "fas fa-skiing";
                    case SearchFilterType.Storby:
                        return "fas fa-city";
                    case SearchFilterType.Bjergby:
                        return "fas fa-mountains";
                    case SearchFilterType.UdsigtVand:
                        return "fas fa-eye";
                    case SearchFilterType.UdsigtNatur:
                        return "fas fa-eye";
                    case SearchFilterType.LadeStander:
                        return "fas fa-charging-station";
                    case SearchFilterType.Varmepumpe:
                        return "fa-kit fa-underfloor-heating";
                    default:
                        return "";
                }
            }
            setPartialSearchCridentials(filters) {
                var self = this;
                self.extend(self.searchCridentials, filters);
            }
            extend(oldObject, newObject) {
                var self = this;
                if (oldObject == null) {
                    oldObject = {};
                }
                for (var key in newObject) {
                    oldObject[key] = newObject[key];
                }
                self.searchCridentials = oldObject;
            }
        }
        SearchwidgetDataservice.BOOKHUS_GREY_PIN = '/content/siteimages/googleMarkers/bookhus_grey_pin.svg';
        SearchwidgetDataservice.BOOKHUS_RED_PIN = '/content/siteimages/googleMarkers/bookuhs_red_pin.svg';
        SearchwidgetDataservice.BOOKHUS_RED_OUTLINE_PIN = '/content/siteimages/googleMarkers/bookhus_red_outline_pin.svg';
        SearchWidget.SearchwidgetDataservice = SearchwidgetDataservice;
    })(SearchWidget = Bookhus.SearchWidget || (Bookhus.SearchWidget = {}));
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    var SearchWidget;
    (function (SearchWidget) {
        class LocalizedSearchValues {
            constructor() {
                this.translations = {
                    AntalPersoner: {
                        da: "Antal personer",
                        "en-GB": "Number of persons",
                        de: "Anzahl der Personen",
                        sv: "Antal personer",
                        no: "Antall personer"
                    },
                    AntalSoveværelser: {
                        da: "Antal soveværelser",
                        "en-GB": "Number of bedrooms",
                        de: "Anzahl der Schlafzimmer",
                        sv: "Antal rum",
                        no: "Antall rom"
                    },
                    Bjergby: {
                        da: "Bjergby",
                        "en-GB": "Mountain city",
                        de: "Bergstadt",
                        sv: "Bergstad",
                        no: "Fjellby"
                    },
                    Brændeovn: {
                        da: "Brændeovn",
                        "en-GB": "Wood stove",
                        de: "Holzofen",
                        sv: "Vedeldad spis",
                        no: "Vedovn"
                    },
                    Boat: {
                        da: "Båd",
                        "en-GB": "Boat",
                        de: "Boot",
                        sv: "Båt",
                        no: "Båt"
                    },
                    Cykler: {
                        da: "Cykler",
                        "en-GB": "Cycles",
                        de: "Fahrräder",
                        sv: "Cyklar",
                        no: "Sykler"
                    },
                    Dag: {
                        da: "dag",
                        "en-GB": "Day",
                        de: "Tag",
                        sv: "dag",
                        no: "dag"
                    },
                    Dage: {
                        da: "dage",
                        "en-GB": "Days",
                        de: "Tage",
                        sv: "dagar",
                        no: "dager"
                    },
                    Ekkolod: {
                        da: "Ekkolod",
                        "en-GB": "Sonar",
                        de: "Sonar",
                        sv: "Ekolod",
                        no: "Ekkolodd"
                    },
                    Faciliteter: {
                        da: "Faciliteter",
                        "en-GB": "Facilities",
                        de: "Einrichtungen",
                        sv: "Faciliteter",
                        no: "Fasiliteter"
                    },
                    Feriecenter: {
                        da: "Feriecenter",
                        "en-GB": "",
                        de: "Ferienzentrum",
                        sv: "Semestercenter",
                        no: "Feriesenter"
                    },
                    Fiskerenseplads: {
                        da: "Fiskerenseplads",
                        "en-GB": "Fish cleaning table",
                        de: "Fischreinigungs",
                        sv: "Fiskrensbord",
                        no: "Sløye"
                    },
                    Garage: {
                        da: "Garage",
                        "en-GB": "Garage",
                        de: "Garage",
                        sv: "Garage",
                        no: "Garasje"
                    },
                    Handicapvenligt: {
                        da: "Handicapvenligt",
                        "en-GB": "Disabled friendly",
                        de: "Behindertengerecht",
                        sv: "Handikappvänlig",
                        no: "Hendicapvenligt"
                    },
                    HavDistance: {
                        da: "Afstand til havet",
                        "en-GB": "Distance to the sea",
                        de: "Nähe zum Meer",
                        sv: "Avstånd till havet",
                        no: "Avstand til sjøen"
                    },
                    Havudsigt: {
                        da: "Havudsigt",
                        "en-GB": "Sea views",
                        de: "Meerblick",
                        sv: "Havsutsikt",
                        no: "Sjø"
                    },
                    Hus: {
                        da: "Hus",
                        "en-GB": "House",
                        de: "Haus",
                        sv: "Hus",
                        no: "Hus"
                    },
                    Husdyr: {
                        da: "Husdyr",
                        "en-GB": "Pets",
                        de: "Haustiere",
                        sv: "Husdjur",
                        no: "Husdyr"
                    },
                    HusdyrIkkeTilladt: {
                        da: "Ingen husdyr tilladt",
                        "en-GB": "Pets not allowed",
                        de: "Haustiere nicht erlaubt",
                        sv: "Husdjur inte tillåtna",
                        no: "Husdyr ikke tillatt"
                    },
                    IkkeValgt: {
                        da: "Ikke valgt",
                        "en-GB": "Not selected",
                        de: "Nicht ausgewählt",
                        sv: "Inte vald",
                        no: "Ikke valgt"
                    },
                    PoolIn: {
                        da: "Indendørs pool",
                        "en-GB": "Indoor pool",
                        de: "Hallenbad",
                        sv: "Inomhuspool",
                        no: "Innendørs basseng"
                    },
                    Internet: {
                        da: "Internet",
                        "en-GB": "Internet",
                        de: "Internet",
                        sv: "Internet",
                        no: "Internett"
                    },
                    KøbmandDistance: {
                        da: "Afstand til købmanden",
                        "en-GB": "Distance to the merchant",
                        de: "Entfernung zum Lebensmittelgeschäft",
                        sv: "Avstånd till köpman",
                        no: "Avstand til matbutikk"
                    },
                    Lejlighed: {
                        da: "Lejlighed",
                        "en-GB": "Apartment",
                        de: "Wohnung",
                        sv: "Lägenhet",
                        no: "Leilighet"
                    },
                    Lokation: {
                        da: "Alle steder",
                        "en-GB": "All locations",
                        de: "Überall",
                        sv: "Alla platser",
                        no: "Alle steder"
                    },
                    Beliggenhed: {
                        da: "Beliggenhed",
                        "en-GB": "Location",
                        de: "Lage",
                        sv: "Plats",
                        no: "Plassering"
                    },
                    Mikroovn: {
                        da: "Mikroovn",
                        "en-GB": "Mircowave",
                        de: "Mikrowelle",
                        sv: "Mikrovågsugn",
                        no: "Mikrobølgeovn"
                    },
                    Nulstil: {
                        da: "Nulstil",
                        "en-GB": "Reset",
                        de: "rücksetzen",
                        sv: "Återståll",
                        no: "Tilbakestille"
                    },
                    Område: {
                        da: "Område",
                        "en-GB": "Area",
                        de: "Bereich",
                        sv: "Område",
                        no: "Område"
                    },
                    Opvaskemaskine: {
                        da: "Opvaskemaskine",
                        "en-GB": "Dishwasher",
                        de: "Spülmaschine",
                        sv: "Diskmaskin",
                        no: "Oppvaskmaskin"
                    },
                    Parabol: {
                        da: "Parabol",
                        "en-GB": "Satellite",
                        de: "Sat. Anschluss",
                        sv: "Parabol",
                        no: "Parabol"
                    },
                    Periode: {
                        da: "Periode",
                        "en-GB": "Period",
                        de: "Zeit",
                        sv: "Period",
                        no: "Periode"
                    },
                    Person: {
                        da: "Person",
                        "en-GB": "Person",
                        de: "Person",
                        sv: "Person",
                        no: "Person"
                    },
                    Personer: {
                        da: "Personer",
                        "en-GB": "Persons",
                        de: "Leute",
                        sv: "Människor",
                        no: "Mennesker"
                    },
                    Radar: {
                        da: "Radar",
                        "en-GB": "Radar",
                        de: "Radar",
                        sv: "Radar",
                        no: "Radar"
                    },
                    VhsRadio: {
                        da: "Vhs radio",
                        "en-GB": "Vhs radio",
                        de: "Vhs radio",
                        sv: "Vhs radio",
                        no: "Vhs radio"
                    },
                    Rygning: {
                        da: "Rygning",
                        "en-GB": "Smoking",
                        de: "Rauchen",
                        sv: "Rökning",
                        no: "Røyking"
                    },
                    Sauna: {
                        da: "Sauna",
                        "en-GB": "Sauna",
                        de: "Sauna",
                        sv: "Bastu",
                        no: "Badstue"
                    },
                    Skiområde: {
                        da: "Skiområde",
                        "en-GB": "Ski area",
                        de: "Skigebiet",
                        sv: "Skidområde",
                        no: "Skiområde"
                    },
                    Spa: {
                        da: "Spa",
                        "en-GB": "Spa",
                        de: "Whirrlpool",
                        sv: "Spa",
                        no: "Spa"
                    },
                    StartDato: {
                        da: "Startdato",
                        "en-GB": "Startdate",
                        de: "Startdatum",
                        sv: "Startdatum",
                        no: "Startdato"
                    },
                    Storby: {
                        da: "Storby",
                        "en-GB": "City",
                        de: "Große stadt",
                        sv: "Storstad",
                        no: "Storby"
                    },
                    Swimmingpool: {
                        da: "Svømmebassin",
                        "en-GB": "Swimmingpool",
                        de: "Schwimmbad",
                        sv: "Simbassäng",
                        no: "Svømmebasseng"
                    },
                    Search: {
                        da: "Søg",
                        "en-GB": "Search",
                        de: "Suche",
                        sv: "Sök",
                        no: "Søk"
                    },
                    MinTwoToilets: {
                        da: "2. toiletter",
                        "en-GB": "2. toilets",
                        de: "2. Toiletten",
                        sv: "2. toaletter",
                        no: "2. toaletter"
                    },
                    Tørretumbler: {
                        da: "Tørretumbler",
                        "en-GB": "Dryer",
                        de: "Trockner",
                        sv: "Torktumlare",
                        no: "Tørketrommel"
                    },
                    PoolOut: {
                        da: "Udendørs pool",
                        "en-GB": "Outdoor pool",
                        de: "Freibad",
                        sv: "Utomhuspool",
                        no: "Utendørs basseng"
                    },
                    UdsigtNatur: {
                        da: "Natur udsigt",
                        "en-GB": "Nature view",
                        de: "",
                        sv: "Naturvyn",
                        no: "Naturutsikt"
                    },
                    LadeStander: {
                        da: "Lade stander",
                        "en-GB": "Charging station",
                        de: "Ladestation",
                        sv: "Laddstation",
                        no: "Ladestasjon"
                    },
                    Varmepumpe: {
                        da: "Varmepumpe",
                        "en-GB": "Heat pump",
                        de: "Wärmepumpe",
                        sv: "Värmepump",
                        no: "Varmepumpe"
                    },
                    UdsigtVand: {
                        da: "Vandudsigt",
                        "en-GB": "Water view",
                        de: "",
                        sv: "Vatten visa",
                        no: "Vannutsikt"
                    },
                    Uge: {
                        da: "Uge",
                        "en-GB": "Week",
                        de: "Woche",
                        sv: "Vecka",
                        no: "Uke"
                    },
                    Uger: {
                        da: "Uger",
                        "en-GB": "Weeks",
                        de: "Wochen",
                        sv: "Veckor",
                        no: "Uker"
                    },
                    Under: {
                        da: "Under",
                        "en-GB": "Under",
                        de: "Unter",
                        sv: "Nedan",
                        no: "Under"
                    },
                    Vaskemaskine: {
                        da: "Vaskemaskine",
                        "en-GB": "Washing machine",
                        de: "Waschmachine",
                        sv: "Tvättmaskin",
                        no: "Vaskemaskine"
                    },
                    VisKatalog: {
                        da: "Vis i katalog",
                        "en-GB": "Show in catalog",
                        de: "In Katalog",
                        sv: "Visa i katalogen",
                        no: "Vis i katalog"
                    },
                    Værelse: {
                        da: "Værelse",
                        "en-GB": "Room",
                        de: "Zimmer",
                        sv: "Rum",
                        no: "Rom"
                    },
                    Værelser: {
                        da: "Værelser",
                        "en-GB": "Rooms",
                        de: "Zimmer",
                        sv: "Rum",
                        no: "Rom"
                    },
                    AdvancedSearch: {
                        da: "Avanceret søgning",
                        "en-GB": "Advanced search",
                        de: "erweiterte Suche",
                        sv: "avancerad sökning",
                        no: "avansert søk"
                    },
                    SearchProperties: {
                        da: "Søgeegenskaber",
                        "en-GB": "Search properties",
                        de: "Sucheigenschaften",
                        sv: "Sökegenskaper",
                        no: "Søkeegenskaper"
                    },
                    Where: {
                        da: "Hvor",
                        "en-GB": "Where",
                        de: "Wo",
                        sv: "Var",
                        no: "Hvor"
                    },
                    When: {
                        da: "Hvornår",
                        "en-GB": "When",
                        de: "Wann",
                        sv: "När",
                        no: "Når"
                    },
                    RoomAndGuest: {
                        da: "Værelser og gæster",
                        "en-GB": "Rooms & Guests",
                        de: "Zimmer & Gäste",
                        sv: "Rum & gäster",
                        no: "Rom og gjester"
                    },
                    PropertyList: {
                        da: "Emneliste",
                        "en-GB": "Propertylist",
                        de: "Objektliste",
                        sv: "Fastighetslista",
                        no: "Eiendomsliste"
                    },
                    ChooseALocation: {
                        da: "Vælg en lokation",
                        "en-GB": "Choose a location",
                        de: "Wählen Sie einen Standort",
                        sv: "Välj en plats",
                        no: "Velg en lokasjon"
                    },
                    ChoosenLocations: {
                        "da": "Valgt: {0}",
                        "en-GB": "Chosen: {0}",
                        "de": "Gewählt: {0}",
                        "sv": "Vald: {0}",
                        "no": "Valgt: {0}"
                    },
                    ChoosenMultipleLocations: {
                        "da": "Valgt: {0} og {1} mere",
                        "en-GB": "Chosen: {0} and {1} more",
                        "de": "Gewählt: {0} und {1} weitere",
                        "sv": "Vald: {0} och {1} mer",
                        "no": "Valgt: {0} og {1} til"
                    },
                    ChooseTags: {
                        "da": "Vælg tags",
                        "en-GB": "Choose tags",
                        "de": "Wählen tags",
                        "sv": "Välja taggar",
                        "no": "Velg tagger"
                    }
                };
            }
            get(name, lang) {
                if (this.translations[name] == undefined || this.translations[name] == null) {
                    return "Oversættelse findes ikke";
                }
                var langCode = $.datepicker.regional.bookhuscurrent;
                if (lang != undefined && lang != null) {
                    langCode = lang;
                }
                var value = this.translations[name][langCode] || this.translations[name]["da"];
                if (value == undefined || value == "") {
                    return "Oversættelse findes ikke";
                }
                return value;
            }
        }
        SearchWidget.LocalizedSearchValues = LocalizedSearchValues;
    })(SearchWidget = Bookhus.SearchWidget || (Bookhus.SearchWidget = {}));
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    var SearchWidget;
    (function (SearchWidget) {
        class GeoLocationWidget {
            constructor(selector, options) {
                if (selector == "" || !selector) {
                    console.log("Selector missing");
                    return;
                }
                this.setOptions(options);
                this.container = $(selector);
                this.injectCSS('/Content/bookhus/geo-location_widget/index.css');
                this.buildContainer();
            }
            setOptions(options) {
                this.options = $.extend(true, {
                    customClass: '',
                    treeData: '' // Default tree data
                }, options);
            }
            injectCSS(href) {
                if (!$(`link[href="${href}"]`).length) {
                    const link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = href;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
            }
            getSearchWidgetLanguage() {
                var bookhus = window.Bookhus;
                if (bookhus
                    && bookhus.Localization
                    && bookhus.Localization.Standard
                    && bookhus.Localization.Standard.UI
                    && bookhus.Localization.Standard.UI.Widgets) {
                    return bookhus.Localization.Standard.UI.Widgets.SearchWidget;
                }
                return null;
            }
            translate(name) {
                var searchWidgetLanguage = this.getSearchWidgetLanguage();
                if (!searchWidgetLanguage) {
                    return "";
                }
                return searchWidgetLanguage[name] || "";
            }
            buildContainer() {
                this.container.addClass(`${this.options.customClass}`);
                this.container.html(`
                <div class="custom-dropdown">
                    <div class="custom-dropdown-toggle form-control" id="geoLocationDropdownToggle">${this.translate("ChooseALocation")}</div>
                    <div class="custom-dropdown-menu" id="geoLocationDropdownMenu">
                        <ul class="tree-container"></ul>
                    </div>
                </div>
            `);
                const treeData = this.parseTreeData(this.options.treeData);
                this.buildTree(treeData, this.container.find('#geoLocationDropdownMenu > ul'));
                this.initEvents();
                this.updateTitle();
            }
            parseTreeData(data) {
                const parseNode = (nodeStr) => {
                    const [nameState, childrenStr] = nodeStr.match(/^([^{}]+)(\{.*\})?$/).slice(1);
                    const [nameStateId, id] = nameState.split(';');
                    var [name, state] = nameState.split(':');
                    if (state.indexOf(";") >= 0) {
                        state = state.split(';')[0];
                    }
                    const node = { name, state: state, id: id || '' };
                    if (childrenStr) {
                        const childrenData = childrenStr.slice(1, -1);
                        node.children = parseChildren(childrenData);
                    }
                    return node;
                };
                const parseChildren = (data) => {
                    const nodes = [];
                    let stack = [];
                    let current = '';
                    for (const char of data) {
                        if (char === '{') {
                            stack.push(current);
                            current = '';
                        }
                        else if (char === '}') {
                            const parent = stack.pop();
                            if (parent !== undefined) {
                                current = `${parent}{${current}}`;
                            }
                        }
                        else if (char === ',' && stack.length === 0) {
                            nodes.push(parseNode(current));
                            current = '';
                        }
                        else {
                            current += char;
                        }
                    }
                    if (current) {
                        nodes.push(parseNode(current));
                    }
                    return nodes;
                };
                return parseNode(data);
            }
            buildTree(node, $parent) {
                if (node.state === 'none') {
                    if (node.children) {
                        node.children.forEach(childNode => this.buildTree(childNode, $parent));
                    }
                    return;
                }
                const $nodeElement = $(`
                <li>
                    <label>
                        <input type="checkbox" value="${node.id}" name="GeoLokation" class="tree-checkbox" data-name="${node.name}">
                        ${node.name}
                    </label>
                </li>
            `);
                $parent.append($nodeElement);
                if (node.children && node.children.length > 0) {
                    const $childrenContainer = $('<ul></ul>');
                    $nodeElement.append($childrenContainer);
                    node.children.forEach(childNode => this.buildTree(childNode, $childrenContainer));
                }
            }
            initEvents() {
                const toggle = this.container.find('#geoLocationDropdownToggle');
                const menu = this.container.find('#geoLocationDropdownMenu');
                toggle.on('click', () => {
                    menu.toggle();
                });
                $(document).on('click', (event) => {
                    if (!this.container.is(event.target) && this.container.has(event.target).length === 0) {
                        menu.hide();
                    }
                });
                this.container.on('click', '.tree-checkbox', (event) => {
                    const $checkbox = $(event.target);
                    const isChecked = $checkbox.is(':checked');
                    this.updateChildren($checkbox, isChecked);
                    this.updateParent($checkbox);
                    this.updateTitle();
                });
            }
            updateTitle() {
                //ChoosenLocations ChoosenMultipleLocations
                var _selectedItems = $("#geoLocationDropdownMenu input:checked");
                if (_selectedItems.length > 0) {
                    var _text = this.FormatString(this.translate("ChoosenLocations"), _selectedItems.first().parent().text());
                    if (_selectedItems.length > 1) {
                        _text = this.FormatString(this.translate("ChoosenMultipleLocations"), _selectedItems.first().parent().text(), "" + (_selectedItems.length - 1));
                    }
                    $("#geoLocationDropdownToggle").text(`${_text}`);
                }
                else {
                    $("#geoLocationDropdownToggle").text(`${this.translate("ChooseALocation")}`);
                }
            }
            updateChildren($checkbox, isChecked) {
                const $childrenContainer = $checkbox.closest('li').find('> ul');
                if ($childrenContainer.length > 0) {
                    $childrenContainer.find('input.tree-checkbox').each((index, childCheckbox) => {
                        $(childCheckbox).prop('checked', isChecked).prop('indeterminate', false);
                        this.updateChildren($(childCheckbox), isChecked);
                    });
                }
            }
            FormatString(str, ...val) {
                for (let index = 0; index < val.length; index++) {
                    str = str.replace(`{${index}}`, val[index]);
                }
                return str;
            }
            updateParent($checkbox) {
                const $parentCheckbox = $checkbox.closest('ul').closest('li').find('> label > input.tree-checkbox');
                if ($parentCheckbox.length > 0) {
                    const $siblings = $checkbox.closest('ul').find('> li > label > input.tree-checkbox');
                    const allChecked = $siblings.length === $siblings.filter(':checked').length;
                    const anyChecked = $siblings.closest("li").find(':checkbox').filter(":checked").length;
                    const isIndeterminate = anyChecked && !allChecked;
                    $parentCheckbox.prop('checked', allChecked).prop('indeterminate', isIndeterminate);
                    this.updateParent($parentCheckbox);
                }
            }
            init() {
            }
        }
        SearchWidget.GeoLocationWidget = GeoLocationWidget;
    })(SearchWidget = Bookhus.SearchWidget || (Bookhus.SearchWidget = {}));
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    var SearchWidget;
    (function (SearchWidget) {
        let SearchFilterType;
        (function (SearchFilterType) {
            SearchFilterType[SearchFilterType["Opvaskemaskine"] = 0] = "Opvaskemaskine";
            SearchFilterType[SearchFilterType["Vaskemaskine"] = 1] = "Vaskemaskine";
            SearchFilterType[SearchFilterType["T\u00F8rretumbler"] = 2] = "T\u00F8rretumbler";
            SearchFilterType[SearchFilterType["Husdyr"] = 3] = "Husdyr";
            SearchFilterType[SearchFilterType["Rygning"] = 4] = "Rygning";
            SearchFilterType[SearchFilterType["Br\u00E6ndeovn"] = 5] = "Br\u00E6ndeovn";
            SearchFilterType[SearchFilterType["Internet"] = 6] = "Internet";
            SearchFilterType[SearchFilterType["Parabol"] = 7] = "Parabol";
            SearchFilterType[SearchFilterType["Handicapvenligt"] = 8] = "Handicapvenligt";
            SearchFilterType[SearchFilterType["Havudsigt"] = 9] = "Havudsigt";
            SearchFilterType[SearchFilterType["MaxPrice"] = 10] = "MaxPrice";
            SearchFilterType[SearchFilterType["Spa"] = 11] = "Spa";
            SearchFilterType[SearchFilterType["Sauna"] = 12] = "Sauna";
            SearchFilterType[SearchFilterType["PoolOut"] = 13] = "PoolOut";
            SearchFilterType[SearchFilterType["PoolIn"] = 14] = "PoolIn";
            SearchFilterType[SearchFilterType["Garage"] = 15] = "Garage";
            SearchFilterType[SearchFilterType["Boat"] = 16] = "Boat";
            SearchFilterType[SearchFilterType["Ekkolod"] = 17] = "Ekkolod";
            SearchFilterType[SearchFilterType["VhsRadio"] = 18] = "VhsRadio";
            SearchFilterType[SearchFilterType["Radar"] = 19] = "Radar";
            SearchFilterType[SearchFilterType["MinTwoToilets"] = 20] = "MinTwoToilets";
            SearchFilterType[SearchFilterType["Fiskerenseplads"] = 21] = "Fiskerenseplads";
            SearchFilterType[SearchFilterType["Mikroovn"] = 22] = "Mikroovn";
            SearchFilterType[SearchFilterType["Cykler"] = 23] = "Cykler";
            SearchFilterType[SearchFilterType["Feriecenter"] = 24] = "Feriecenter";
            SearchFilterType[SearchFilterType["Swimmingpool"] = 25] = "Swimmingpool";
            SearchFilterType[SearchFilterType["Hus"] = 26] = "Hus";
            SearchFilterType[SearchFilterType["Lejlighed"] = 27] = "Lejlighed";
            SearchFilterType[SearchFilterType["Skiomr\u00E5de"] = 28] = "Skiomr\u00E5de";
            SearchFilterType[SearchFilterType["Storby"] = 29] = "Storby";
            SearchFilterType[SearchFilterType["Bjergby"] = 30] = "Bjergby";
            SearchFilterType[SearchFilterType["UdsigtVand"] = 31] = "UdsigtVand";
            SearchFilterType[SearchFilterType["UdsigtNatur"] = 32] = "UdsigtNatur";
            SearchFilterType[SearchFilterType["LadeStander"] = 33] = "LadeStander";
            SearchFilterType[SearchFilterType["Varmepumpe"] = 34] = "Varmepumpe";
            SearchFilterType[SearchFilterType["HusdyrIkkeTilladt"] = 35] = "HusdyrIkkeTilladt";
        })(SearchFilterType || (SearchFilterType = {}));
        class SearchWidgetWide {
            constructor(selector, options) {
                this.isApplyingSearchFilter = false;
                this.timeStripOffset = 0;
                this.timeStripDaysToShow = 6;
                if (selector == "" || !selector) {
                    return;
                }
                this.setOptions(options);
                this.dataService = new SearchWidget.SearchwidgetDataservice();
                this.container = $(selector);
                this.buildContainer();
            }
            getSearchWidgetLanguage() {
                var bookhus = window.Bookhus;
                if (bookhus
                    && bookhus.Localization
                    && bookhus.Localization.Standard
                    && bookhus.Localization.Standard.UI
                    && bookhus.Localization.Standard.UI.Widgets) {
                    return bookhus.Localization.Standard.UI.Widgets.SearchWidget;
                }
                return null;
            }
            getGeneralTextLanguage() {
                var bookhus = window.Bookhus;
                if (bookhus
                    && bookhus.Localization
                    && bookhus.Localization.Standard
                    && bookhus.Localization.Standard.UI) {
                    return bookhus.Localization.Standard.UI.GeneralText;
                }
                return null;
            }
            translate(name) {
                var searchWidgetLanguage = this.getSearchWidgetLanguage();
                if (!searchWidgetLanguage) {
                    return "";
                }
                switch (name) {
                    case "HavDistance":
                        return searchWidgetLanguage.HavDistance || searchWidgetLanguage.Hav || "";
                    case "KøbmandDistance":
                        return searchWidgetLanguage.KøbmandDistance || searchWidgetLanguage.Købmand || "";
                    case "MaxPrice":
                        return searchWidgetLanguage.MaxPrice || searchWidgetLanguage["Maks pris"] || "";
                    case "Search":
                        return searchWidgetLanguage.Search || searchWidgetLanguage.Søg || "";
                    default:
                        return searchWidgetLanguage[name] || "";
                }
            }
            translateGeneralText(name, fallback) {
                var generalTextLanguage = this.getGeneralTextLanguage();
                var value = generalTextLanguage ? generalTextLanguage[name] : null;
                return value || fallback;
            }
            buildContainer() {
                this.container.addClass(`container card p-3 ${this.options.customClass}`);
                var { controlSettings } = this.options;
                var showExtendedSearch = controlSettings.showDistanceToGrocer || controlSettings.showDistanceToSea || (controlSettings.facilities && controlSettings.facilities.length > 0);
                this.container.html(`
                <h4 class="font-weight-bold mb-3">${this.translate('SearchProperties')}</h4>
                <div class="row pb-2" id="searchContainer"></div>
                <div class="d-flex justify-content-between align-items-center">
					${(showExtendedSearch ? `<a data-toggle="collapse" href="#searchMore"  class="text-secondary text-decoration-none"><i class="icon-ic_more_home mr-2"></i>${this.translate("AdvancedSearch")}</a>` : '')}

                    <button type="button" class="btn btn-outline-dark ml-auto mr-3" data-command="resetfilters">${this.translate("Nulstil")}</button>
                    <button type="button" class="btn btn-primary btnWidth" data-command="search">${this.translate("Search")}</button>
				</div>
                ${(showExtendedSearch ? '<div class="collapse pt-3" id="searchMore"></div>' : '')}
            `);
                this.searchContainer = this.container.find('#searchContainer');
                this.extSearchContainer = $("div#searchMore");
            }
            setOptions(options) {
                this.options = $.extend(true, {
                    callSearchWhenInitiated: false,
                    search: (filters) => {
                        var params = $.param(filters);
                        window.location.href = this.options.searchBaseFilterUri + '?' + params;
                    },
                    customClass: '',
                    loadGeoLocationWidget: false,
                    searchBaseFilterUri: '',
                    showTimeCalendarStrip: false,
                    showTagsAsButtons: false,
                    controlSettings: {
                        showPeriod: true,
                        maxPeriodDays: 14,
                        selectedPeriodDay: 6,
                        showRooms: true,
                        maxRooms: 7,
                        showPersons: true,
                        maxPersons: 20,
                        showDistanceToSea: false,
                        showDistanceToGrocer: false,
                        showArea: true,
                        showRelationship: false,
                        useGeoLocation: false,
                        useGeographicAndLocationsInSearch: false,
                        geoLocationData: "",
                        facilities: []
                    }
                }, options);
                if (this.options.controlSettings.selectedPeriodDay >= this.options.controlSettings.maxPeriodDays) {
                    this.options.controlSettings.selectedPeriodDay = this.options.controlSettings.maxPeriodDays - 1;
                }
            }
            init() {
                document.addEventListener('controls_rendered', () => {
                    this.isApplyingSearchFilter = true;
                    const hasSearchFilter = this.setSearchFilter();
                    this.isApplyingSearchFilter = false;
                    this.renderTimeCalendarStrip();
                    if (hasSearchFilter || this.options.callSearchWhenInitiated) {
                        this.loadFilteredData();
                    }
                });
                this.renderFilters();
                this.renderFacilities();
                this.initEvents();
                this.bindTimeCalendarStripEvents();
                this.renderTimeCalendarStrip();
            }
            formatDateForStartInput(date) {
                return $.datepicker.formatDate($.datepicker.regional.bookhuscurrent == "en-GB" ? "mm/dd/yy" : "dd-mm-yy", date);
            }
            parseStartDateValue(value) {
                if (!value) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return today;
                }
                const localizedFormat = $.datepicker.regional.bookhuscurrent == "en-GB" ? "mm/dd/yy" : "dd-mm-yy";
                const formats = ["yy-mm-dd", localizedFormat, "dd/mm/yy"];
                for (const format of formats) {
                    try {
                        const parsed = $.datepicker.parseDate(format, value);
                        parsed.setHours(0, 0, 0, 0);
                        return parsed;
                    }
                    catch (_a) {
                    }
                }
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return today;
            }
            sameDate(a, b) {
                return a.getFullYear() === b.getFullYear()
                    && a.getMonth() === b.getMonth()
                    && a.getDate() === b.getDate();
            }
            setTimeStripOffsetFromDate(date) {
                if (!this.options.showTimeCalendarStrip || !date) {
                    return;
                }
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                date.setHours(0, 0, 0, 0);
                if (isNaN(date.getTime())) {
                    return;
                }
                const daysFromToday = Math.floor((date.getTime() - today.getTime()) / 86400000);
                this.timeStripOffset = Math.max(0, daysFromToday - (daysFromToday % this.timeStripDaysToShow));
            }
            getStripMonthTitle(date) {
                const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'];
                return `${months[date.getMonth()]} ${date.getFullYear()}`;
            }
            getStripWeekday(date) {
                const days = ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'];
                return days[date.getDay()];
            }
            renderTimeCalendarStrip() {
                if (!this.options.showTimeCalendarStrip) {
                    return;
                }
                const $strip = $('#catalogTimeCalendarStrip');
                const $title = $('#catalogTimeCalendarStripMonth');
                const $startDate = $('#startDate');
                if ($strip.length === 0 || $title.length === 0 || $startDate.length === 0) {
                    return;
                }
                const selectedDate = this.parseStartDateValue(String($startDate.val() || ''));
                const baseDate = new Date();
                baseDate.setHours(0, 0, 0, 0);
                baseDate.setDate(baseDate.getDate() + this.timeStripOffset);
                $title.text(this.getStripMonthTitle(baseDate));
                $strip.empty();
                const prevDisabled = this.timeStripOffset <= 0;
                $strip.append(`
        <div class="catalog-time-card catalog-time-card-prev ${prevDisabled ? 'disabled' : ''}" id="catalogTimeCalendarStripPrev">
            <span>&larr;</span>
        </div>
    `);
                for (let i = 0; i < this.timeStripDaysToShow; i++) {
                    const current = new Date(baseDate);
                    current.setDate(baseDate.getDate() + i);
                    const isToday = i === 0 && this.timeStripOffset === 0;
                    const isActive = this.sameDate(current, selectedDate);
                    const label = isToday ? 'Today' : this.getStripWeekday(current);
                    const day = current.getDate();
                    $strip.append(`
            <div class="catalog-time-card ${isActive ? 'active' : ''}" data-date="${this.formatDateForStartInput(current)}">
                <div class="catalog-time-card-inner">
                    <div class="catalog-time-card-label">${label}</div>
                    <div class="catalog-time-card-day">${day}</div>
                </div>
            </div>
        `);
                }
                $strip.append(`
        <div class="catalog-time-card catalog-time-card-next" id="catalogTimeCalendarStripNext">
            <span>&rarr;</span>
        </div>
    `);
            }
            bindTimeCalendarStripEvents() {
                if (!this.options.showTimeCalendarStrip) {
                    return;
                }
                $(document)
                    .off('click.timeCalendarStrip', '#catalogTimeCalendarStrip .catalog-time-card[data-date]')
                    .on('click.timeCalendarStrip', '#catalogTimeCalendarStrip .catalog-time-card[data-date]', (e) => {
                    const $target = $(e.currentTarget);
                    const value = String($target.data('date') || '');
                    const currentValue = String($('#startDate').val() || '');
                    if (currentValue === value) {
                        this.renderTimeCalendarStrip();
                        return;
                    }
                    const parsed = this.parseStartDateValue(value);
                    $('#startDate').datepicker('setDate', parsed).trigger('change');
                    this.renderTimeCalendarStrip();
                });
                $(document)
                    .off('click.timeCalendarStripPrev', '#catalogTimeCalendarStripPrev')
                    .on('click.timeCalendarStripPrev', '#catalogTimeCalendarStripPrev', () => {
                    if (this.timeStripOffset <= 0) {
                        return;
                    }
                    this.timeStripOffset = Math.max(0, this.timeStripOffset - this.timeStripDaysToShow);
                    this.renderTimeCalendarStrip();
                });
                $(document)
                    .off('click.timeCalendarStripNext', '#catalogTimeCalendarStripNext')
                    .on('click.timeCalendarStripNext', '#catalogTimeCalendarStripNext', () => {
                    this.timeStripOffset += this.timeStripDaysToShow;
                    this.renderTimeCalendarStrip();
                });
                $(document)
                    .off('change.timeCalendarStrip', '#startDate')
                    .on('change.timeCalendarStrip', '#startDate', () => {
                    this.setTimeStripOffsetFromDate(this.parseStartDateValue(String($('#startDate').val() || '')));
                    this.renderTimeCalendarStrip();
                });
            }
            renderFilters() {
                var self = this;
                var { controlSettings } = this.options;
                var controls = "";
                var locationPromise = null;
                if (controlSettings.useGeoLocation && controlSettings.useGeographicAndLocationsInSearch && controlSettings.geoLocationData.indexOf("checked") > -1 ||
                    controlSettings.useGeoLocation && controlSettings.geoLocationData.indexOf("checked") > -1) {
                    controls += `
                    <div class="col-lg-4">
                        <div class="form-group">
						    <label class="mb-1" >${self.translate("Område")}</label>
						    <div id="geoLocationWidgetContainer">
                            </div>
					    </div>
                    </div>
                `;
                }
                else if (controlSettings.showArea) {
                    controls += `
                    <div class="col-lg-4">
                        <div class="form-group">
						    <label class="mb-1" >${self.translate("Område")}</label>
						    <select class="form-control" id="locations" name="lokation" data-searchable="true" aria-labelledby="areaLabel">
							    <option value="0">${self.translate("IkkeValgt")}</option>
						    </select>
					    </div>
                    </div>
                `;
                }
                var tagsPromise = null;
                if (self.options.showTagsAsButtons) {
                    controls += `
                        <div class="col-12 mb-3">
                            <div class="form-group time-tags-group">
                                <label id="tagsLabel" class="mb-2">Tags</label>
                                <div id="timeTags" class="time-tags-buttons"></div>
                                <input type="hidden" id="selectedTags" name="tags" />
                            </div>
                        </div>
                    `;
                }
                else {
                    controls += `
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label id="tagsLabel" class="mb-1">Tags</label>
                                <select class="form-control" id="tags" multiple="multiple" name="tags" aria-labelledby="tagsLabel"></select>
                            </div>
                        </div>
                    `;
                }
                var select2Promise = null;
                if (!self.options.showTagsAsButtons && typeof $.fn.select2 !== "function") {
                    if (!document.querySelector('link[data-search-widget-select2]')) {
                        $('head').append('<link data-search-widget-select2 href="https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css" rel="stylesheet" type="text/css">');
                    }
                    select2Promise = $.ajax({
                        url: "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js",
                        dataType: "script",
                        cache: true,
                        timeout: 10000
                    }).then(() => { }, () => {
                        // Keep the native multiple select usable when the CDN is unavailable.
                        console.warn("Select2 could not be loaded; using the native tag selector.");
                    });
                }
                tagsPromise = this.dataService.loadLocations().then(() => {
                    var locationData = this.dataService.locations || [];
                    if (self.options.showTagsAsButtons) {
                        var tagButtons = "";
                        for (var i = 0; i < locationData.length; i++) {
                            tagButtons += `
                <button type="button"
                        class="btn btn-outline-secondary btn-sm time-tag-btn me-2 mb-2"
                        data-tag-id="${locationData[i].id}">
                    ${locationData[i].name}
                </button>
            `;
                        }
                        $('#timeTags').html(tagButtons);
                    }
                    else {
                        var locations = "";
                        for (var i = 0; i < locationData.length; i++) {
                            locations += `<option value="${locationData[i].id}">${locationData[i].name}</option>`;
                        }
                        $('#tags').append(locations);
                    }
                });
                var relationshipPromise = null;
                if (controlSettings.showRelationship) {
                    controls += `
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label id="relationshipLabel" class="mb-1" >${self.translateGeneralText("Relationship", self.translate("Relationship"))}</label>
                                <select class="form-control" id="relationship" name="relationship" aria-labelledby="relationshipLabel">
									<option value="-1">${self.translate("IkkeValgt")}</option>
								</select>
                            </div>
                        </div>
                    `;
                    relationshipPromise = this.dataService.loadRelationship().then(() => {
                        var relationshipData = this.dataService.relationships || [];
                        var relationships = "";
                        for (var i = 0; i < relationshipData.length; i++) {
                            relationships += `<option value="${relationshipData[i].id}">${relationshipData[i].name}</option>`;
                        }
                        $('#relationship').append(relationships);
                    });
                }
                if (controlSettings.showRooms || controlSettings.showPersons) {
                    var roomControl = "";
                    if (controlSettings.showRooms) {
                        var rooms = "";
                        for (var i = 2; i <= (controlSettings.maxRooms || 4); i++) {
                            rooms += `<option value="${i}">${i} ${self.translate("Værelser")}</option>`;
                        }
                        roomControl = `
                        <div class="col-4 pr-0">
						    <div class="form-group">
							    <label id="roomcountLabel" class="mb-1" >${self.translate("Værelser")}</label>
                                <select class="form-control" name="roomcount" data-searchable="true" aria-labelledby="roomcountLabel">
                                    <option value="0">${self.translate("IkkeValgt")}</option>
                                    <option value="1">1 ${self.translate("Værelse")}</option>
                                    ${rooms}
                                </select>
						    </div>
					    </div>
                    `;
                    }
                    var personControl = "";
                    if (controlSettings.showPersons) {
                        var persons = "";
                        for (var i = 2; i <= (controlSettings.maxPersons || 8); i++) {
                            persons += `<option value="${i}">${i} ${self.translate("Personer")}</option>`;
                        }
                        personControl = `
                        <div class="col">
							<div class="form-group">
								<label id="personCountLabel" class="mb-1" >${self.translate("Personer")}</label>
								<select class="form-control" name="personcount" data-searchable="true" aria-labelledby="personCountLabel">
									<option value="0">${self.translate("IkkeValgt")}</option>
                                    <option value="1">1 ${self.translate("Person")}</option>
                                    ${persons}
								</select>
							</div>
						</div>
                    `;
                    }
                    controls += `
                    <div class="col-lg-4">
                        <div class="row">
                            ${roomControl}
                            ${personControl}
                        </div>
                    </div>
                `;
                }
                if (controlSettings.showPeriod) {
                    var weeks = `<option value="0">1 ${self.translate("Dag")}</option>`;
                    for (var i = 1; i < (controlSettings.maxPeriodDays || 28); i++) {
                        var tekst = "";
                        if ((i + 1) % 7 == 0) {
                            var week = (i + 1) / 7;
                            if (week == 1) {
                                tekst = week + " " + self.translate("Uge");
                            }
                            else {
                                tekst = week + " " + self.translate("Uger");
                            }
                        }
                        else {
                            tekst = (i + 1) + " " + self.translate("Dage");
                        }
                        weeks += `<option ${i == controlSettings.selectedPeriodDay ? "selected" : ""} value="${i}">${tekst}</option>`;
                    }
                    controls += `
                        <div class="col-md-8">
                            <div class="form-group time-period-group ${self.options.showTimeCalendarStrip ? 'time-active' : ''}">
                                <label>${self.translate("Periode")}</label>
                                <div class="row time-period-fields">
                                    <div class="col-md-6 time-period-start">
                                        <input type="text"
                                               id="startDate"
                                               name="arrivalDate"
                                               placeholder="${self.translate("StartDato")}"
                                               class="datePicker form-control"
                                               data-searchable="true"
                                               data-keyup="true"
                                               aria-label="Startdato" />
                                        <input type="hidden" id="endDate" name="departureDate" />
                                        <input type="hidden" id="houseIds" name="houseIds" />
                                    </div>
                                    <div class="col-md-6 time-period-length">
                                        <select class="form-control" id="periodWeeks" name="days" data-searchable="true" aria-label="Periodens længde">
                                            ${weeks}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                    if (self.options.showTimeCalendarStrip) {
                        controls += `
                        <div class="col-12">
                            <div class="catalog-time-strip-wrapper">
                                <div class="catalog-time-strip-month mb-3" id="catalogTimeCalendarStripMonth"></div>
                                <div class="catalog-time-strip-row" id="catalogTimeCalendarStrip"></div>
                            </div>
                        </div>
                    `;
                    }
                }
                self.searchContainer.html(controls);
                self.applySearchFilterValues(self.parseQueryString(location.search.substring(1)));
                var controlRenderedEvent = new CustomEvent('controls_rendered');
                var controlsRenderedDispatched = false;
                var dispatchControlsRendered = () => {
                    if (controlsRenderedDispatched) {
                        return;
                    }
                    controlsRenderedDispatched = true;
                    window.setTimeout(() => {
                        document.dispatchEvent(controlRenderedEvent);
                    }, 0);
                };
                if (controlSettings.useGeoLocation) {
                    var geoLocationWidget = new Bookhus.SearchWidget.GeoLocationWidget("#geoLocationWidgetContainer", {
                        customClass: '',
                        treeData: this.options.controlSettings.geoLocationData,
                    });
                    geoLocationWidget.init();
                }
                if (!self.options.showTagsAsButtons) {
                    tagsPromise = $.when(tagsPromise, select2Promise).then(() => {
                        if (typeof $.fn.select2 === "function") {
                            $("#tags").select2({
                                placeholder: self.translate("ChooseTags"),
                                tokenSeparators: [',', ' ']
                            });
                        }
                    });
                }
                var promiseArray = [];
                if (tagsPromise) {
                    promiseArray.push(tagsPromise);
                }
                if (relationshipPromise) {
                    promiseArray.push(relationshipPromise);
                }
                if (promiseArray.length > 0) {
                    $.when.apply($, promiseArray).always(dispatchControlsRendered);
                    window.setTimeout(dispatchControlsRendered, 500);
                }
                else {
                    dispatchControlsRendered();
                }
            }
            renderFacilities() {
                var self = this;
                var { controlSettings } = this.options;
                var controlGroup = "";
                if (controlSettings.showDistanceToSea || controlSettings.showDistanceToGrocer) {
                    var distanceToSeaControl = "";
                    if (controlSettings.showDistanceToSea) {
                        distanceToSeaControl = `
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label id="havDistanceLabel" class="mb-1 font-weight-bold" >${self.translate("HavDistance")}</label>
                                <select class="form-control" name="havDistance" aria-labelledby="havDistanceLabel">
									<option value="-1">${self.translate("IkkeValgt")}</option>
                                    <option value="1">${self.translate("Under")} 100m</option>
                                    <option value="2">${self.translate("Under")} 200m</option>
                                    <option value="3">${self.translate("Under")} 500m</option>
                                    <option value="4">${self.translate("Under")} 1000m</option>
                                    <option value="5">${self.translate("Under")} 2000m</option>
                                    <option value="6">${self.translate("Under")} 3000m</option>
								</select>
                            </div>
                        </div>
                    `;
                    }
                    var distanceToGrocer = "";
                    if (controlSettings.showDistanceToGrocer) {
                        distanceToGrocer += `
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label id="groceryStoreDistanceLabel" class="mb-1 font-weight-bold">${self.translate("KøbmandDistance")}</label>
                            <select class="form-control" name="købmandDistance" aria-labelledby="groceryStoreDistanceLabel">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
                    }
                    controlGroup = `
                    <div class="row pb-3">
                        ${distanceToSeaControl}
                        ${distanceToGrocer}
					</div>
                `;
                }
                var facilityGroup = "";
                var filters = controlSettings.facilities || [];
                if (filters.length > 0) {
                    var facilities = "";
                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i];
                        facilities += `
                        <div class="col-6 col-lg-3">
							<label class="custom-control custom-checkbox d-flex align-items-center">
								<input type="checkbox" name="${SearchFilterType[filter]}" class="custom-control-input">
								<span class="custom-control-label"><i class="mr-2 ml-2 ${self.dataService.GetCssIcon(filter)} mt-1 d-inline-block"></i> ${self.translate(SearchFilterType[filter])}</span>
							</label>
						</div>
                    `;
                    }
                    facilityGroup = `
                    <div class="form-group mb-0">
                        <label class="mb-1 font-weight-bold">${self.translate("Faciliteter")}</label>
                        <div class="row font-size-1">
                            ${facilities}
                        </div>
                    </div>
                `;
                }
                var html = `
                ${controlGroup}
                ${facilityGroup}
            `;
                self.extSearchContainer.html(html);
            }
            initEvents() {
                var self = this;
                $('#startDate').datepicker(Object.assign({ showWeek: true }, ($.datepicker.regional.bookhuscurrent == "en-GB" && { dateFormat: 'mm/dd/yy' })));
                $('[data-command="resetfilters"]').on('click', (e) => {
                    $(self.container.find('input, select, textarea')).each((index, element) => {
                        var current = $(element);
                        if (current.prop('type') == "checkbox") {
                            current.prop('checked', false);
                            current.prop('indeterminate', false);
                            return;
                        }
                        if (current.attr('name') == "days") {
                            current.val('6');
                            return;
                        }
                        if (current.attr('name') == "købmandDistance" || current.attr('name') == "havDistance") {
                            current.val('-1');
                            return;
                        }
                        if (current.prop('nodeName') == "INPUT" || current.prop('nodeName') == "TEXTAREA") {
                            current.val('');
                            return;
                        }
                        if (current.prop('nodeName') == "SELECT") {
                            current.val('0');
                            return;
                        }
                    });
                    self.loadFilteredData();
                });
                $('[data-command="search"]').on('click', (e) => {
                    self.loadFilteredData();
                });
                self.container
                    .off('change.searchWidgetPets', 'input[name="Husdyr"], input[name="HusdyrIkkeTilladt"]')
                    .on('change.searchWidgetPets', 'input[name="Husdyr"], input[name="HusdyrIkkeTilladt"]', function () {
                    var current = $(this);
                    if (!current.is(':checked')) {
                        return;
                    }
                    var oppositeName = current.attr('name') === 'Husdyr' ? 'HusdyrIkkeTilladt' : 'Husdyr';
                    self.container.find(`input[name="${oppositeName}"]`).prop('checked', false);
                });
                $(document)
                    .off('click.searchWidgetTimeTags', '.time-tag-btn')
                    .on('click.searchWidgetTimeTags', '.time-tag-btn', function () {
                    $(this).toggleClass('active btn-primary').toggleClass('btn-outline-secondary');
                    var selected = [];
                    $('.time-tag-btn.active').each(function () {
                        selected.push(String($(this).data('tag-id')));
                    });
                    $('#selectedTags').val(selected.join(','));
                    self.loadFilteredData();
                });
                $("#locations, #relationship, #tags, #startDate, select[name='days'], select[name='roomcount'], select[name='personcount'], input[name='GeoLokation']").change((e) => {
                    if (self.isApplyingSearchFilter) {
                        return;
                    }
                    self.loadFilteredData();
                });
                //self.container.find('[data-searchable="true"], .ExtendedSearch input, .ExtendedSearch select').on('change', (index, element) => {
                //    self.loadFilteredData();
                //});
                self.container.find('[data-keyup="true"]').on('keyup', () => {
                    self.debounce(self.loadFilteredData(), 100, false);
                });
            }
            applySearchFilterValues(cridentials) {
                var self = this;
                for (var key in cridentials) {
                    if (!cridentials.hasOwnProperty(key)) {
                        continue;
                    }
                    var element = $('[name="' + key + '"]');
                    var value = cridentials[key];
                    if (key === "tags") {
                        var tagValues = self.getFilterValues(value);
                        if (self.options.showTagsAsButtons) {
                            self.setTimeTagButtons(tagValues);
                        }
                        else if (element.length) {
                            element.val(tagValues);
                            if (element.data("select2-id") != undefined) {
                                element.trigger('change.select2');
                            }
                        }
                        continue;
                    }
                    if (element.length === 0) {
                        continue;
                    }
                    if (key === "arrivalDate") {
                        var parsedArrivalDate = self.parseStartDateValue(String(value));
                        try {
                            element.datepicker('setDate', parsedArrivalDate);
                        }
                        catch (_a) {
                            element.val(self.formatDateForStartInput(parsedArrivalDate));
                        }
                        self.setTimeStripOffsetFromDate(parsedArrivalDate);
                        continue;
                    }
                    if (element.attr('type') === 'checkbox') {
                        element.prop('checked', value == "true");
                    }
                    else if (element.data("select2-id") != undefined) {
                        element.val(value).trigger('change.select2');
                    }
                    else {
                        element.val(value);
                    }
                }
                var petsAllowed = self.container.find('input[name="Husdyr"]');
                var petsNotAllowed = self.container.find('input[name="HusdyrIkkeTilladt"]');
                if (petsAllowed.is(':checked') && petsNotAllowed.is(':checked')) {
                    petsNotAllowed.prop('checked', false);
                }
            }
            setSearchFilter() {
                var self = this;
                var search = location.search.substring(1);
                var cridentials = self.parseQueryString(search);
                self.applySearchFilterValues(cridentials);
                return search.length > 0;
            }
            parseQueryString(search) {
                var result = {};
                if (!search) {
                    return result;
                }
                var parts = search.split('&');
                for (var i = 0; i < parts.length; i++) {
                    if (!parts[i]) {
                        continue;
                    }
                    var pair = parts[i].split('=');
                    var key = decodeURIComponent((pair.shift() || '').replace(/\+/g, ' ')).replace(/\[\]$/, '');
                    var value = decodeURIComponent(pair.join('=').replace(/\+/g, ' '));
                    if (!key) {
                        continue;
                    }
                    if (result[key] == undefined) {
                        result[key] = value;
                    }
                    else if ($.isArray(result[key])) {
                        result[key].push(value);
                    }
                    else {
                        result[key] = [result[key], value];
                    }
                }
                return result;
            }
            getFilterValues(value) {
                var values = [];
                var source = $.isArray(value) ? value : [value];
                for (var i = 0; i < source.length; i++) {
                    var parts = String(source[i]).split(',');
                    for (var j = 0; j < parts.length; j++) {
                        var item = $.trim(parts[j]);
                        if (item.length > 0 && $.inArray(item, values) === -1) {
                            values.push(item);
                        }
                    }
                }
                return values;
            }
            setTimeTagButtons(tagValues) {
                var selectedTags = {};
                for (var i = 0; i < tagValues.length; i++) {
                    selectedTags[String(tagValues[i])] = true;
                }
                $('.time-tag-btn').each(function () {
                    var $button = $(this);
                    var isSelected = selectedTags[String($button.data('tag-id'))] === true;
                    $button
                        .toggleClass('active btn-primary', isSelected)
                        .toggleClass('btn-outline-secondary', !isSelected);
                });
                $('#selectedTags').val(tagValues.join(','));
            }
            loadFilteredData() {
                var filters = this.getFilters();
                this.options.search(filters);
            }
            getFilters() {
                var self = this;
                var filters = {};
                $(self.container.find('input, select, textarea')).each((index, element) => {
                    var current = $(element);
                    if (current.attr('name') == undefined) {
                        return;
                    }
                    if (current.prop('type') == "checkbox" && current.attr('value') != undefined) {
                        if (!current.is(':checked')) {
                            return;
                        }
                        var propertyKey = current.attr('name');
                        var propertyValue = filters[propertyKey];
                        if (propertyValue == undefined || propertyValue == null) {
                            filters[propertyKey] = current.val();
                        }
                        else if (Array.isArray(filters[propertyKey])) {
                            filters[propertyKey].push(current.val());
                        }
                        else {
                            filters[propertyKey] = [propertyValue, current.val()];
                        }
                    }
                    else if (current.prop('type') == "checkbox") {
                        filters[current.attr('name')] = current.is(':checked');
                    }
                    else {
                        var value = current.val();
                        if (current.attr('name') == 'tags' && typeof value === 'string' && value.indexOf(',') > -1) {
                            filters[current.attr('name')] = value.split(',');
                            return;
                        }
                        if (current.attr('name') === 'arrivalDate' && typeof value === "string") {
                            value = this.fixDateFormat(value, $.datepicker.regional.bookhuscurrent);
                        }
                        filters[current.attr('name')] = value;
                    }
                });
                return filters;
            }
            fixDateFormat(dateStr, culture = "da") {
                if (!dateStr) {
                    return dateStr;
                }
                const localizedFormat = culture === 'en-GB' ? 'mm/dd/yy' : 'dd-mm-yy';
                const formats = ['yy-mm-dd', localizedFormat, 'dd/mm/yy'];
                for (const format of formats) {
                    try {
                        const parsed = $.datepicker.parseDate(format, dateStr);
                        return $.datepicker.formatDate('yy-mm-dd', parsed);
                    }
                    catch (_a) {
                    }
                }
                return dateStr;
            }
            debounce(func, wait, immediate) {
                var timeout;
                return function () {
                    var context = this, args = arguments;
                    var later = function () {
                        timeout = null;
                        if (!immediate)
                            func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow)
                        func.apply(context, args);
                };
            }
        }
        SearchWidget.SearchWidgetWide = SearchWidgetWide;
    })(SearchWidget = Bookhus.SearchWidget || (Bookhus.SearchWidget = {}));
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    class LiteEvent {
        constructor() {
            this.handlers = [];
        }
        on(handler) {
            this.handlers.push(handler);
        }
        off(handler) {
            this.handlers = this.handlers.filter(h => h !== handler);
        }
        trigger(data) {
            this.handlers.slice(0).forEach(h => h(data));
        }
        expose() {
            return this;
        }
    }
    Bookhus.LiteEvent = LiteEvent;
    class GoogleMaps {
        constructor(containerSelector, googleApiKey, settings, isAdmin = false) {
            var self = this;
            self.container = $(containerSelector);
            self.mergeSettings(settings);
            if (isAdmin) {
                self.settings.displayStaticMap = false;
            }
            self.container.append(`
                <div class="google-maps"></div>
            `);
            self.googleMapsManager = new Bookhus.GoogleMapsManager($('.google-maps'), googleApiKey, self.settings);
            self.searchDataService = new Bookhus.SearchwidgetDataservice();
            self.container.append(`                
                <div class="google-position-top-left"></div>
                <div class="google-position-top-center"></div>
                <div class="google-position-top-right"></div>
                <div class="google-position-left-top"></div>
                <div class="google-position-left-center"></div>
                <div class="google-position-left-bottom"></div>
                <div class="google-position-right-top"></div>
                <div class="google-position-right-center"></div>
                <div class="google-position-right-bottom"></div>
                <div class="google-position-bottom-left"></div>
                <div class="google-position-bottom-center"></div>
                <div class="google-position-bottom-right"></div>
            `);
            self.googleControlsContainer = $('.google-controls');
            self.setupControls();
        }
        setupControls() {
            var self = this;
            if (self.settings.zoomControl) {
                var selector = self.getPositionSelector(self.settings.zoomControlOption.position);
                if (selector != "") {
                    var zoomControl = new Bookhus.ZoomControl(self.googleMapsManager);
                    $(selector).append(zoomControl.renderHtml());
                    zoomControl.initEvents();
                }
            }
            if (self.settings.mapTypeControl) {
                var selector = self.getPositionSelector(self.settings.mapTypeControlOption.position);
                if (selector != "") {
                    var mapControl = new Bookhus.MapTypeControl(self.googleMapsManager);
                    $(selector).append(mapControl.renderHtml());
                    mapControl.initEvents();
                }
            }
            if (self.settings.streetViewControl) {
                var selector = self.getPositionSelector(self.settings.streetViewControlOption.position);
                if (selector != "") {
                    var streetViewControl = new Bookhus.StreetViewControl(self.googleMapsManager);
                    $(selector).append(streetViewControl.renderHtml());
                    streetViewControl.initEvents();
                }
            }
            if (self.settings.fullScreenControl) {
                var selector = self.getPositionSelector(self.settings.fullScreenControlOption.position);
                if (selector != "") {
                    var fullScreenControl = new Bookhus.FullScreenControl(self.container, self.googleMapsManager);
                    $(selector).append(fullScreenControl.renderHtml());
                    fullScreenControl.initEvents();
                }
            }
            if (self.settings.searchControl) {
                var selector = self.getPositionSelector(self.settings.searchControlOption.position);
                if (selector != "") {
                    var searchControl = new Bookhus.SearchControl(self.container, self.googleMapsManager, self.searchDataService);
                    $(selector).append(searchControl.renderHtml());
                    searchControl.init();
                }
            }
            if (self.settings.locationControl) {
                var selector = self.getPositionSelector(self.settings.locationControlOption.position);
                if (selector != "") {
                    var locationControl = new Bookhus.LocationControl(self.googleMapsManager, self.searchDataService);
                    $(selector).append(locationControl.renderHtml());
                    locationControl.initEvents();
                }
            }
            self.googleMapsManager.onInitMap.on((map) => {
                google.maps.event.addListener(map.getStreetView(), 'visible_changed', () => {
                    var visible = map.getStreetView().getVisible();
                    if (visible) {
                        $('[class^="google-position"]').css('z-index', 0);
                    }
                    else {
                        $('[class^="google-position"]').css('z-index', 1);
                    }
                });
            });
            self.updateCenterPositions();
        }
        updateCenterPositions() {
            var self = this;
            var containerWidth = self.container.width() / 2;
            var containerHeight = self.container.height() / 2;
            var horizontalCenter = $('.google-position-top-center, .google-position-bottom-center');
            horizontalCenter.css('left', containerWidth);
            horizontalCenter.css('transform', `translateX(-50%)`);
            var verticalCenter = $('.google-position-left-center, .google-position-right-center');
            verticalCenter.css('top', containerHeight);
            verticalCenter.css('transform', `translateY(-50%)`);
        }
        mergeSettings(settings) {
            var self = this;
            self.settings = {
                zoom: 6,
                center: { lat: 55.814666, lng: 10.588629 },
                maxFitZoom: 10,
                displayDynamicMapOverlay: false,
                markerClusterOption: {
                    maxZoom: 10,
                    gridSize: 10,
                    styles: [
                        {
                            width: 30,
                            height: 30,
                            className: "custom-clustericon-1",
                        },
                        {
                            width: 40,
                            height: 40,
                            className: "custom-clustericon-2",
                        },
                        {
                            width: 50,
                            height: 50,
                            className: "custom-clustericon-3",
                        }
                    ],
                    clusterClass: "custom-clustericon"
                },
                searchControl: true,
                searchControlOption: {
                    position: "LEFT_CENTER",
                    style: "default",
                    text: "Søg",
                    autoOpen: false
                },
                fullScreenControl: true,
                fullScreenControlOption: {
                    position: "TOP_RIGHT",
                    style: "default",
                    fullscreenText: "Gør mindre",
                    defaultText: "Gør større"
                },
                zoomControl: true,
                zoomControlOption: {
                    position: "RIGHT_CENTER",
                    style: "default"
                },
                streetViewControl: false,
                streetViewControlOption: {
                    position: "RIGHT_CENTER",
                    style: "default"
                },
                mapTypeControl: false,
                mapTypeControlOption: {
                    position: "TOP_CENTER",
                    style: "default",
                    defaultMap: "roadmap"
                },
                locationControl: true,
                locationControlOption: {
                    position: "TOP_LEFT",
                    style: "default"
                },
                displayStaticMap: true
            };
            $.extend(true, self.settings, settings);
        }
        getPositionSelector(position) {
            switch (position) {
                case "TOP_LEFT":
                    return ".google-position-top-left";
                case "TOP_CENTER":
                    return ".google-position-top-center";
                case "TOP_RIGHT":
                    return ".google-position-top-right";
                case "LEFT_TOP":
                    return ".google-position-left-top";
                case "LEFT_CENTER":
                    return ".google-position-left-center";
                case "LEFT_BOTTOM":
                    return ".google-position-left-bottom";
                case "RIGHT_TOP":
                    return ".google-position-right-top";
                case "RIGHT_CENTER":
                    return ".google-position-right-center";
                case "RIGHT_BOTTOM":
                    return ".google-position-right-bottom";
                case "BOTTOM_LEFT":
                    return ".google-position-bottom-left";
                case "BOTTOM_CENTER":
                    return ".google-position-bottom-center";
                case "BOTTOM_RIGHT":
                    return ".google-position-bottom-right";
                default:
                    return "";
            }
        }
    }
    Bookhus.GoogleMaps = GoogleMaps;
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    class GoogleMapsSearchService {
        constructor() {
            var self = this;
            self.dataService = new Bookhus.SearchwidgetDataservice();
        }
        loadDataAjax() {
            var self = this;
            return self.dataService.loadDataAjax();
        }
        searchData(filters) {
            var self = this;
            if (filters) {
                self.searchCridentials = filters;
            }
            return self.dataService.searchData(self.searchCridentials);
        }
        loadControlSettings() {
            var self = this;
            return self.dataService.loadControlSettings();
        }
        loadLocations() {
            var self = this;
            return self.dataService.loadLocations();
        }
        getControlSettings() {
            var self = this;
            return self.dataService.controlSettings;
        }
        getMarkers() {
            var self = this;
            return self.dataService.markers;
        }
        getLocations() {
            var self = this;
            return self.dataService.locations;
        }
        GetCssIcon(type) {
            var self = this;
            return self.dataService.GetCssIcon(type);
        }
        getGoogleMarkers(googleMap, overlay) {
            var self = this;
            var result = [];
            self.dataService.markers.forEach((marker) => {
                var googleMarker = new google.maps.Marker({
                    position: marker.position,
                    icon: {
                        url: GoogleMapsSearchService.BOOKHUS_GREY_PIN,
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    title: marker.title,
                    map: googleMap,
                    markerId: 0,
                    markerType: null
                });
                var content = `<span id="infowindow_${marker.type}_${marker.id}"></span>${marker.description}`;
                var infowindow = new google.maps.InfoWindow({
                    content: content,
                    disableAutoPan: true
                });
                googleMarker.addListener("click", () => {
                    var self = this;
                    infowindow.open(googleMap, googleMarker);
                    var img = $("#iw-container-" + marker.id + " img");
                    var url = img.data("src");
                    img.attr("src", url);
                });
                google.maps.event.addListener(infowindow, 'domready', function () {
                    var img = $("#iw-container-" + marker.id + " img");
                    var url = img.data("src");
                    img.attr("src", url);
                    var projection = overlay.getProjection();
                    //Convert position to pixel
                    var point = projection.fromLatLngToContainerPixel(googleMarker.getPosition());
                    var container = $(`#infowindow_${marker.type}_${marker.id}`).parents('.gm-style-iw.gm-style-iw-c:first');
                    //Calculate new latlng based on pixel
                    point.y = point.y - (container.height() / 2) - 20;
                    //Convert pixel back to position
                    var position = projection.fromContainerPixelToLatLng(point);
                    googleMap.panTo(position);
                });
                result.push(googleMarker);
            });
            return result;
        }
        setPartialSearchCridentials(filters) {
            var self = this;
            self.extend(self.searchCridentials, filters);
        }
        extend(oldObject, newObject) {
            for (var key in newObject) {
                oldObject[key] = newObject[key];
            }
        }
    }
    GoogleMapsSearchService.BOOKHUS_GREY_PIN = '/content/siteimages/googleMarkers/bookhus_grey_pin.svg';
    GoogleMapsSearchService.BOOKHUS_RED_PIN = '/content/siteimages/googleMarkers/bookuhs_red_pin.svg';
    GoogleMapsSearchService.BOOKHUS_RED_OUTLINE_PIN = '/content/siteimages/googleMarkers/bookhus_red_outline_pin.svg';
    Bookhus.GoogleMapsSearchService = GoogleMapsSearchService;
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    class GoogleControls {
        constructor(mapManager) {
            var self = this;
            self.mapManager = mapManager;
        }
        async getMap(e, eventToTrigger = "click") {
            var self = this;
            return new Promise((resolve, reject) => {
                var map = self.mapManager.getMap();
                if (map == null) {
                    self.mapManager.initMap(() => {
                        $(e.target).trigger(eventToTrigger);
                    });
                    reject();
                    return;
                }
                resolve(map);
            });
        }
    }
    Bookhus.GoogleControls = GoogleControls;
    class ZoomControl extends GoogleControls {
        constructor(mapManager) {
            super(mapManager);
            var self = this;
        }
        renderHtml() {
            return `
                <div class="google-control zoom-control">
                    <button class="zoom-control-in" title="Zoom ind">+</button>
                    <div class="divider"></div>
                    <button class="zoom-control-out" title="Zoom ud">−</button>
                </div>
            `;
        }
        initEvents() {
            var self = this;
            $('.zoom-control-in').on('click', (e) => {
                self.getMap(e).then((map) => {
                    map.setZoom(map.getZoom() + 1);
                });
            });
            $('.zoom-control-out').on('click', (e) => {
                self.getMap(e).then((map) => {
                    map.setZoom(map.getZoom() - 1);
                });
            });
        }
    }
    Bookhus.ZoomControl = ZoomControl;
    class MapTypeControl extends GoogleControls {
        constructor(mapManager) {
            super(mapManager);
            var self = this;
            self.options = self.mapManager.settings.mapTypeControlOption;
        }
        renderHtml() {
            return `
                <div class="google-control maptype-control">
                    <button class="maptype-control-map" title="Show road map">Map</button>
                    <button class="maptype-control-satellite" title="Show satellite imagery">Satellite</button>
                </div>
            `;
        }
        initEvents() {
            var self = this;
            var mapTypeControlDiv = $('.maptype-control');
            self.mapManager.onInitMap.on((map) => {
                switch (self.options.defaultMap) {
                    case 'roadmap':
                        mapTypeControlDiv.addClass('maptype-control-is-map');
                        mapTypeControlDiv.removeClass('maptype-control-is-satellite');
                        map.setMapTypeId('roadmap');
                        break;
                    case 'hybrid':
                        mapTypeControlDiv.removeClass('maptype-control-is-map');
                        mapTypeControlDiv.addClass('maptype-control-is-satellite');
                        map.setMapTypeId('hybrid');
                        break;
                }
            });
            $('.maptype-control-map').on('click', function (e) {
                self.getMap(e).then((map) => {
                    mapTypeControlDiv.addClass('maptype-control-is-map');
                    mapTypeControlDiv.removeClass('maptype-control-is-satellite');
                    map.setMapTypeId('roadmap');
                });
            });
            $('.maptype-control-satellite').on('click', function (e) {
                self.getMap(e).then((map) => {
                    mapTypeControlDiv.removeClass('maptype-control-is-map');
                    mapTypeControlDiv.addClass('maptype-control-is-satellite');
                    map.setMapTypeId('hybrid');
                });
            });
        }
    }
    Bookhus.MapTypeControl = MapTypeControl;
    class StreetViewControl extends GoogleControls {
        constructor(mapManager) {
            super(mapManager);
            var self = this;
        }
        renderHtml() {
            //throw new Error("Method not implemented.");
            return "";
        }
        initEvents() {
            //throw new Error("Method not implemented.");
        }
    }
    Bookhus.StreetViewControl = StreetViewControl;
    class FullScreenControl extends GoogleControls {
        constructor(container, mapManager) {
            super(mapManager);
            this.document = document;
            var self = this;
            self.container = container[0];
            self.options = self.mapManager.settings.fullScreenControlOption;
        }
        renderHtml() {
            return `
                <div class="google-control fullscreen-control">
                    <button>
                        Gør større
                    </button>
                </div>
            `;
        }
        initEvents() {
            var self = this;
            $('.fullscreen-control button').on('click', (e) => {
                self.getMap(e).then((map) => {
                    if (self.isFullscreen()) {
                        self.exitFullscreen();
                    }
                    else {
                        self.requestFullscreen();
                    }
                });
            });
            self.document.onwebkitfullscreenchange =
                self.document.onmsfullscreenchange =
                    self.document.onmozfullscreenchange =
                        self.document.onfullscreenchange = function () {
                            if (self.isFullscreen()) {
                                $(self.container).css('height', '100%');
                                $('.fullscreen-control button').html(self.options.fullscreenText);
                            }
                            else {
                                $(self.container).css('height', '');
                                $('.fullscreen-control button').html(self.options.defaultText);
                            }
                        };
        }
        isFullscreen() {
            var self = this;
            return (self.document.fullscreenElement ||
                self.document.webkitFullscreenElement ||
                self.document.mozFullScreenElement ||
                self.document.msFullscreenElement) == self.container;
        }
        requestFullscreen() {
            var self = this;
            if (self.container.requestFullscreen) {
                self.container.requestFullscreen();
            }
            else if (self.container.webkitRequestFullScreen) {
                self.container.webkitRequestFullScreen();
            }
            //Der er ingen defination af moz eller ms, så derfor bliver contaienr castet til any "(<any>self.container)"
            else if (self.container.mozRequestFullScreen) {
                self.container.mozRequestFullScreen();
            }
            else if (self.container.msRequestFullScreen) {
                self.container.msRequestFullScreen();
            }
        }
        exitFullscreen() {
            var self = this;
            if (self.document.exitFullscreen) {
                self.document.exitFullscreen();
            }
            else if (self.document.webkitExitFullscreen) {
                self.document.webkitExitFullscreen();
            }
            else if (self.document.mozCancelFullScreen) {
                self.document.mozCancelFullScreen();
            }
            else if (self.document.msCancelFullScreen) {
                self.document.msCancelFullScreen();
            }
        }
    }
    Bookhus.FullScreenControl = FullScreenControl;
    class SearchControl extends GoogleControls {
        constructor(container, mapManager, searchDataService) {
            super(mapManager);
            var self = this;
            container.append(`<div class="search-control-filters brand-background-transparent"></div>`);
            self.filterContainer = container.find('.search-control-filters');
            self.options = self.mapManager.settings.searchControlOption;
            self.searchDataService = searchDataService;
        }
        getSearchWidgetLanguage() {
            var bookhus = window.Bookhus;
            if (bookhus
                && bookhus.Localization
                && bookhus.Localization.Standard
                && bookhus.Localization.Standard.UI
                && bookhus.Localization.Standard.UI.Widgets) {
                return bookhus.Localization.Standard.UI.Widgets.SearchWidget;
            }
            return null;
        }
        getGeneralTextLanguage() {
            var bookhus = window.Bookhus;
            if (bookhus
                && bookhus.Localization
                && bookhus.Localization.Standard
                && bookhus.Localization.Standard.UI) {
                return bookhus.Localization.Standard.UI.GeneralText;
            }
            return null;
        }
        translate(name) {
            var searchWidgetLanguage = this.getSearchWidgetLanguage();
            if (!searchWidgetLanguage) {
                return "";
            }
            switch (name) {
                case "HavDistance":
                    return searchWidgetLanguage.HavDistance || searchWidgetLanguage.Hav || "";
                case "KøbmandDistance":
                    return searchWidgetLanguage.KøbmandDistance || searchWidgetLanguage.Købmand || "";
                case "MaxPrice":
                    return searchWidgetLanguage.MaxPrice || searchWidgetLanguage["Maks pris"] || "";
                default:
                    return searchWidgetLanguage[name] || "";
            }
        }
        translateGeneralText(name, fallback) {
            var generalTextLanguage = this.getGeneralTextLanguage();
            var value = generalTextLanguage ? generalTextLanguage[name] : null;
            return value || fallback;
        }
        init() {
            var self = this;
            $.when(self.searchDataService.loadControlSettings(), self.searchDataService.loadLocations(), self.searchDataService.loadRelationships()).done(() => {
                self.renderFilters();
                self.initEvents();
            });
        }
        renderFilters() {
            var self = this;
            //Temp variabler start
            var periode = "Periode";
            var startdato = "Startdato";
            //Temp variabler slut
            var controls = "";
            if (self.searchDataService.controlSettings.showPeriod) {
                var weeks = `<option value="0">1 ${self.translate("Dag")}</option>`;
                for (var i = 1; i < (self.searchDataService.controlSettings.maxPeriodDays || 28); i++) {
                    var tekst = "";
                    if ((i + 1) % 7 == 0) {
                        var week = (i + 1) / 7;
                        if (week == 1) {
                            tekst = week + " " + self.translate("Uge");
                        }
                        else {
                            tekst = week + " " + self.translate("Uger");
                        }
                    }
                    else {
                        tekst = (i + 1) + " " + self.translate("Dage");
                    }
                    weeks += `<option ${i == 6 ? "selected" : ""} value="${i}">${tekst}</option>`;
                }
                controls += `
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>${self.translate("Periode")}</label>
                            <div class="row">
                                <div class="col-md-6">
                                    <input type="text" id="startDate" name="arrivalDate" placeholder="${self.translate("StartDato")}" class="datePicker form-control" aria-label="Startdato"/>
                                </div>
                                <div class="col-md-6">
                                    <select class="form-control" id="periodWeeks" name="days" aria-label="Periodens længde">
                                        ${weeks}
                                    </select>                                                
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }
            if (self.searchDataService.controlSettings.showRooms) {
                var rooms = "";
                for (var i = 2; i <= (self.searchDataService.controlSettings.maxRooms || 4); i++) {
                    rooms += `<option value="${i}">${i} ${self.translate("Værelser")}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label id="roomcountLabel">${self.translate("Værelser")}</label>
                            <select class="form-control" name="roomcount" aria-labelledby="roomcountLabel">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                <option value="1">1 ${self.translate("Værelse")}</option>
                                ${rooms}
                            </select>
                        </div>            
                    </div>
                `;
            }
            if (self.searchDataService.controlSettings.showPersons) {
                var persons = "";
                for (var i = 2; i <= (self.searchDataService.controlSettings.maxPersons || 8); i++) {
                    persons += `<option value="${i}">${i} ${self.translate("Personer")}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label id="personCountLabel">${self.translate("AntalPersoner")}</label>
                            <select class="form-control" name="personcount" aria-labelledby="personCountLabel">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                <option value="1">1 ${self.translate("Person")}</option>
                                ${persons}
                            </select>
                        </div>
                    </div>
                `;
            }
            if (self.searchDataService.controlSettings.showDistanceToSea) {
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label id="havDistanceLabel">${self.translate("HavDistance")}</label>
                            <select class="form-control" name="havDistance" aria-labelledby="havDistanceLabel">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
            }
            if (self.searchDataService.controlSettings.showDistanceToGrocer) {
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label id="groceryStoreDistanceLabel">${self.translate("KøbmandDistance")}</label>
                            <select class="form-control" name="købmandDistance" aria-labelledby="groceryStoreDistanceLabel">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
            }
            if (self.searchDataService.controlSettings.showArea) {
                var locationData = self.searchDataService.locations || [];
                var locations = "";
                for (var i = 0; i < locationData.length; i++) {
                    locations += `<option value="${locationData[i].id}">${locationData[i].name}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label id="locationsLabel">${self.translate("Område")}</label>
                            <select class="form-control" id="locations" name="lokation" aria-labelledby="locationsLabel">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                ${locations}
                            </select>
                        </div>
                    </div>
                `;
            }
            if (self.searchDataService.controlSettings.showRelationship) {
                var relationshipData = self.searchDataService.relationships || [];
                var relationships = "";
                for (var i = 0; i < relationshipData.length; i++) {
                    relationships += `<option value="${relationshipData[i].id}">${relationshipData[i].name}</option>`;
                }
                controls += `
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label id="relationshipLabel" class="mb-1 font-weight-bold" >${self.translateGeneralText("Relationship", self.translate("Relationship"))}</label>
                                <select class="form-control" id="relationship" name="relationship" aria-labelledby="relationshipLabel">
									<option value="-1">${self.translate("IkkeValgt")}</option>
                                    ${relationships}
								</select>
                            </div>
                        </div>
                    `;
            }
            var facilities = "";
            var filters = self.searchDataService.controlSettings.facilities || [];
            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                facilities += `
                    <div class="col-md-4">
                        <span class="${self.searchDataService.GetCssIcon(filter)} brand-background" style="height: 27px; width: 27px; font-size: 1.75em; margin-right: 5px;"></span>
                        <label style="position: absolute; font-weight: normal; margin-bottom: 0;">
                        <input type="checkbox"  name="${Bookhus.SearchFilterType[filter]}"/> ${self.translate(Bookhus.SearchFilterType[filter])}</label>
                    </div>
                `;
            }
            var html = "";
            html = `
<div>
    <div class="row">
        <div class="col-md-12">
            <h4 style="color:white; display: inline;">${self.translate("Søg")}</h4>
        </div>
    </div>
    <div class="row">
        ${controls}
    </div>    
    <div class="row">
        <div class="col-md-12"><label>${self.translate("Faciliteter")}</label></div>
        ${facilities}
    </div>
</div>
<span class="btnGroup pull-right">
    <button type="button" data-command="resetFilters">${self.translate("Nulstil")}</button>                    
    <button type="button" data-command="showInCatalog">${self.translate("VisKatalog")}</button>
</span>
`;
            self.filterContainer.html(html);
            if (self.options.autoOpen) {
                self.filterContainer.addClass('open');
            }
        }
        loadData() {
            var self = this;
            if (self.map == null) {
                return;
            }
            var xhr = self.searchDataService.loadDataAjax();
            xhr.always(() => {
                self.mapManager.removeMarkers();
                self.mapManager.setMarkers(self.searchDataService.getGoogleMarkers(self.map, self.mapManager.getOverlay()));
                self.mapManager.fitBounds(self.mapManager.settings.maxFitZoom);
            });
        }
        loadFilteredData() {
            var self = this;
            var filters = {};
            $(self.filterContainer.find('input, select, textarea')).each((index, element) => {
                var current = $(element);
                if (current.prop('type') == "checkbox") {
                    filters[current.attr('name')] = current.is(':checked');
                }
                else {
                    filters[current.attr('name')] = current.val();
                }
            });
            var xhr = this.searchDataService.searchData(filters);
            if (xhr) {
                xhr.always(() => {
                    self.mapManager.removeMarkers();
                    if (self.searchDataService.markers.length > 0) {
                        self.mapManager.setMarkers(self.searchDataService.getGoogleMarkers(self.map, self.mapManager.getOverlay()));
                        self.mapManager.fitBounds(self.mapManager.settings.maxFitZoom);
                    }
                });
            }
        }
        debounce(fn, delay) {
            var timeoutId;
            return function debounced() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                var args = arguments;
                timeoutId = setTimeout(() => { fn.apply(this, args); }, delay);
            };
        }
        renderHtml() {
            var self = this;
            return `
                <div class="search-control">
                    <span class="fa fa-search" aria-hidden="true"></span>
                    <span style="font-size: 0.5em;">${self.options.text}</span>
                </div>`;
        }
        initEvents() {
            var self = this;
            $(".search-control").on("click", (e) => {
                self.getMap(e).then((map) => {
                    $('.search-control-filters').toggleClass('open');
                    self.map = map;
                });
            });
            $('.search-control-filters input, .search-control-filters select').on('change', (e) => {
                self.loadFilteredData();
            });
            $('.search-control-filters :text').on('keyup', () => {
                self.debounce(self.loadFilteredData(), 100);
            });
            $('[data-command="resetFilters"]').on('click', (e) => {
                $(self.filterContainer.find('input, select, textarea')).each((index, element) => {
                    var current = $(element);
                    if (current.prop('type') == "checkbox") {
                        current.prop('checked', false);
                        return;
                    }
                    if (current.attr('name') == "days") {
                        current.val('6');
                        return;
                    }
                    if (current.attr('name') == "købmandDistance" || current.attr('name') == "havDistance") {
                        current.val('-1');
                        return;
                    }
                    if (current.prop('nodeName') == "INPUT" || current.prop('nodeName') == "TEXTAREA") {
                        current.val('');
                        return;
                    }
                    if (current.prop('nodeName') == "SELECT") {
                        current.val('0');
                        return;
                    }
                });
                self.loadData();
            });
            $('[data-command="showInCatalog"]').on('click', () => {
                var url = "/catalog";
                $(self.filterContainer.find('input[name], select[name], textarea[name]')).each((index, element) => {
                    var current = $(element);
                    var value;
                    if (current.prop('type') == "checkbox") {
                        value = current.is(':checked');
                    }
                    else {
                        value = current.val();
                    }
                    url += (index == 0 ? "?" : "&") + current.attr('name') + "=" + value;
                });
                url += "&bypassCache=true";
                window.location.href = url;
            });
            self.mapManager.onLocationChange.on((selectedValue) => {
                $('#locations').val(selectedValue.toString());
            });
            $('#locations').on('change', function (e) {
                var selectedValue = $(e.target).val();
                self.mapManager.onLocationChange.trigger(selectedValue);
            });
            self.mapManager.onInitMap.on((map) => {
                self.map = map;
                self.loadFilteredData();
            });
        }
    }
    Bookhus.SearchControl = SearchControl;
    class LocationControl extends GoogleControls {
        constructor(mapManager, searchDataService) {
            super(mapManager);
            var self = this;
            self.searchDataService = searchDataService;
            self.options = self.mapManager.settings.locationControlOption;
        }
        renderHtml() {
            var self = this;
            //Hvis locations endnu ikke er blevet loaded.. Hent dem og render html senere
            if (self.searchDataService.locations == undefined || self.searchDataService.locations.length <= 0) {
                self.searchDataService.loadLocations().then(() => {
                    $('.location-control').append(self.renderOptions());
                });
            }
            return `
                <select class="google-control location-control" aria-label="Lokation">
                    <option value="0">Alle steder</option>
                    ${self.renderOptions()}
                </select>
            `;
        }
        initEvents() {
            var self = this;
            $('.location-control').on('change', (e) => {
                self.getMap(e, 'change').then((map) => {
                    var selectedValue = 0;
                    try {
                        selectedValue = parseInt($(e.target).val());
                    }
                    catch (_a) {
                        console.log("Valgte lokation værdi er ikke et tal");
                        return;
                    }
                    self.searchDataService.setPartialSearchCridentials({ lokation: selectedValue });
                    self.loadFilteredData(map);
                    self.mapManager.onLocationChange.trigger(selectedValue);
                });
            });
            self.mapManager.onLocationChange.on((selectedValue) => {
                $('.location-control').val(selectedValue.toString());
            });
            self.mapManager.onInitMap.on((map) => {
                self.loadFilteredData(map);
            });
        }
        loadFilteredData(map) {
            var self = this;
            self.searchDataService.searchData().always(() => {
                self.mapManager.removeMarkers();
                if (self.searchDataService.markers.length > 0) {
                    self.mapManager.setMarkers(self.searchDataService.getGoogleMarkers(map, self.mapManager.getOverlay()));
                    self.mapManager.fitBounds(self.mapManager.settings.maxFitZoom);
                }
            });
        }
        renderOptions() {
            var self = this;
            var result = "";
            if (self.searchDataService.locations && self.searchDataService.locations.length > 0) {
                for (var i = 0; i < self.searchDataService.locations.length; i++) {
                    var current = self.searchDataService.locations[i];
                    result += `<option value="${current.id}">${current.name}</option>`;
                }
            }
            return result;
        }
    }
    Bookhus.LocationControl = LocationControl;
})(Bookhus || (Bookhus = {}));
var Bookhus;
(function (Bookhus) {
    class GoogleMapsManager {
        get onInitMap() { return this._onInitMap.expose(); }
        constructor(container, googleApiKey, settings) {
            this.map = null;
            this.overlay = null;
            this.markerClusterer = null;
            this._onInitMap = new Bookhus.LiteEvent();
            this.onLocationChange = new Bookhus.LiteEvent();
            var self = this;
            self.settings = settings;
            self.container = container;
            self.googleApiKey = googleApiKey;
            if (settings.displayStaticMap) {
                self.setImageUrl('/GetStaticGmap/0');
            }
            else {
                self.initMap();
            }
        }
        initMap(callback) {
            var self = this;
            $.when($.getScript("https://maps.googleapis.com/maps/api/js?key=" + self.googleApiKey), $.getScript("/Scripts/MarkerClusterer/index.min.js")).then(function () {
                self.map = new google.maps.Map(self.container[0], {
                    disableDefaultUI: true,
                    center: self.settings.center,
                    zoom: self.settings.zoom,
                    streetViewControl: true,
                    streetViewControlOptions: {
                        position: google.maps.ControlPosition["RIGHT_BOTTOM"]
                    }
                });
                self.overlay = new google.maps.OverlayView();
                self.overlay.setMap(self.map);
                self.markerClusterer = new MarkerClusterer(self.map, null, self.settings.markerClusterOption);
                if (callback) {
                    callback();
                }
                self._onInitMap.trigger(self.map);
            });
        }
        getMap() {
            var self = this;
            return self.map;
        }
        getOverlay() {
            var self = this;
            return self.overlay;
        }
        setImageUrl(imgUrl) {
            var self = this;
            var img = self.container.children('img');
            if (img.length > 0) {
                img.prop('src', imgUrl);
                return;
            }
            self.container.html(`
                <img class="googleMapsStaticImage img-responsive" src="${imgUrl}" style="height: 400px; width: 580px;" alt="Statisk billede af google maps"></img>
                ${(self.settings.displayDynamicMapOverlay ? `<div class="googleMapStaticMessage"><p>Klik for at aktivere dynamisk kort</p></div>` : "")}
            `);
            $('.googleMapStaticMessage, .googleMapsStaticImage').on('click', function () {
                self.initMap(function () { });
            });
        }
        removeMarkers() {
            if (this.markerClusterer == null) {
                return;
            }
            this.markerClusterer.clearMarkers();
        }
        setMarkers(items) {
            if (this.markerClusterer == null) {
                return;
            }
            this.markerClusterer.clearMarkers();
            this.markerClusterer.addMarkers(items);
        }
        fitBounds(maxFitZoom) {
            if (this.map == null || this.markerClusterer == null) {
                return;
            }
            var markers = this.markerClusterer.getMarkers();
            if (markers && markers.length > 0) {
                var bounds = new google.maps.LatLngBounds();
                markers.forEach((marker, index) => {
                    bounds.extend(marker.getPosition());
                });
                this.map.fitBounds(bounds);
                if (this.map.getZoom() > maxFitZoom) {
                    this.map.setZoom(maxFitZoom);
                }
            }
            else {
                this.map.setCenter(this.settings.center);
                this.map.setZoom(this.settings.zoom);
            }
        }
    }
    Bookhus.GoogleMapsManager = GoogleMapsManager;
})(Bookhus || (Bookhus = {}));

﻿$(function () {

    BindCalendars();
});

// Til brug for updatepanels så kalenderne bliver bundet igen efter partiel postback
$(document).ready(function () {
    try {
        if (typeof Sys === "undefined") {
            // do nothing
        }
        else {
            // Sys is something
            Sys.WebForms.PageRequestManager.getInstance().add_endRequest(EndRequestHandler);
            function EndRequestHandler() {
                BindCalendars();
            }
        }
    } catch (e) {

    }
});

function BindCalendars() {
    var datefield = document.createElement("input");
    datefield.setAttribute("type", "date");

    //if (datefield.type != "date") { /* chrome fejler når man ønsker et andet format end US i datoer.. derfor er det slået fra... */
        $(".datePicker").datepicker(
           {
               /*dateFormat: 'yy-mm-dd',
               dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
               dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
               dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
               monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
               monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
               /*dateFormat: 'dd-mm-yy',*/
               constrainInput: true,
               firstDay: 1,
               showWeek: true,
               changeYear: true,
               changeMonth: true,
               /*weekHeader: 'Uge',*/
               yearRange: '2013:+36',
               beforeShow: function () {
                   setTimeout(function () {
                       $('.ui-datepicker').css('z-index', 99999999999999);
                   }, 0);
                },
               altFormat: 'yy-mm-dd'
           });
        //Sætter dato til dato fra input
        $(".datePickerDynamic").datepicker(
                    {
                        /*dateFormat: 'yy-mm-dd',
                        dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                        dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                        dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                        monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
                        dateFormat: 'dd-mm-yy',
                        constrainInput: true,
                        firstDay: 1,
                        showWeek: true,
                        changeYear: true,
                        changeMonth: true,
                        /*weekHeader: 'Uge',*/
                        yearRange: '2013:+36',
                        beforeShow: function () {
                            setTimeout(function () {
                                $('.ui-datepicker').css('z-index', 99999999999999);
                            }, 0);
                        }
                    });
        $(".birthdayDatePicker").datepicker(
               {
                   /*dateFormat: 'yy-mm-dd',
                   dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                   dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                   dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                   monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                   monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
                   /*dateFormat: 'dd-mm-yy',*/
                   constrainInput: true,
                   firstDay: 1,
                   showWeek: true,
                   changeYear: true,
                   changeMonth: true,
                   /*weekHeader: 'Uge',*/
                   yearRange: '1930:+100',
                    beforeShow: function (element) {
                        if ($(element).attr('readonly')) { return false; }
                       setTimeout(function () {
                           $('.ui-datepicker').css('z-index', 99999999999999);
                       }, 0);
                   }
               });

        $(".datePickerClicktoShow").datepicker(
           {
               /*dateFormat: 'yy-mm-dd',
               dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
               dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
               dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
               monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
               monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
               /*dateFormat: 'dd-mm-yy',*/
               constrainInput: true,
               firstDay: 1,
               showWeek: true,
               changeYear: true,
               changeMonth: true,
               /*weekHeader: 'Uge',*/
               yearRange: '2013:+36',
               beforeShow: function () {
                   setTimeout(function () {
                       $('.ui-datepicker').css('z-index', 99999999999999);
                   }, 0);
               }
        });

        var dateFormat = "dd-mm-yyyy";
        var regional = $.datepicker.regional[$.datepicker.regional.bookhuscurrent];
        if (regional != null && regional != undefined) {
            dateFormat = regional.dateFormat;
        }  
              
        if($.datepicker.regional.bookhuscurrent == "da") {
            dateFormat = dateFormat.replace("yy", "åååå");
        }
        else {
            dateFormat = dateFormat.replace("yy", "yyyy");
        }
        

    $('.datePicker, .datePickerDynamic, .birthdayDatePicker, .datePickerClicktoShow').prop("placeholder", dateFormat);


    //date time picker
    const minuteInterval = 5;
    if ($.fn.datetimepicker) {
        $(".dateTimePicker").datetimepicker({
            dateFormat: 'dd-mm-yy',
            showSecond: false,
            showMillisec: false,
            showMicrosec: false,
            stepMinute: minuteInterval,
            minDateTime: roundToNearestMinuteInterval(new Date(), minuteInterval)
        });
    } else {
        console.error("datetimepicker is not loaded. Make sure the script is included.");
    }

    function roundToNearestMinuteInterval(datetime, minuteInterval) {
        return new Date(datetime.setMinutes(Math.round(datetime.getMinutes() / minuteInterval) * minuteInterval));
    }

    //}
}
return Bookhus;};